export default {
  data () {
    return {
      formsMetaData: {
        MeldebegruendungTypesSelect: [
          { value: 'I', text: 'Patientin/Patient wurde informiert und hat nicht widersprochen' },
          { value: 'A', text: 'Ausnahme: Patientenunterrichtung entfallen wegen möglicher gesundheitlicher Nachteile' },
          { value: 'D', text: 'Meldung von Ärzten ohne unmittelbaren Patientenkontakt' },
          { value: 'W', text: 'Patient hat der personenbezogenen Speicherung widersprochen' },
          { value: 'V', text: 'Verstorben' }
        ],
        MeldeanlassTypes: {
          register: [
            { value: 'diagnose', text: 'Diagnose' }
          ],
          progress: [
            { value: 'statusaenderung', text: 'Statusänderung' },
            { value: 'statusmeldung', text: 'Statusmeldung' }
          ],
          operation: [
            { value: 'behandlungsende', text: 'Behandlungsende' }
          ],
          systemicTherapy: [
            { value: 'behandlungsbeginn', text: 'Behandlungsbeginn' },
            { value: 'behandlungsende', text: 'Behandlungsende' }
          ],
          radiationTherapy: [
            { value: 'behandlungsbeginn', text: 'Behandlungsbeginn' },
            { value: 'behandlungsende', text: 'Behandlungsende' }
          ],
          tumorConference: [
            { value: 'diagnose', text: 'Diagnose' },
            { value: 'statusmeldung', text: 'Statusmeldung' },
            { value: 'statusaenderung', text: 'Statusänderung' },
            { value: 'behandlungsbeginn', text: 'Behandlungsbeginn' },
            { value: 'behandlungsende', text: 'Behandlungsende' }
          ],
          death: [
            { value: 'tod', text: 'Tod' }
          ]
        },
        ICD_VersionTypes: [
          { value: '10 2026 GM', text: 'ICD 10 Version 2026 GM', misdValue: '2026' },
          { value: '10 2025 GM', text: 'ICD 10 Version 2025 GM', misdValue: '2025' },
          { value: '10 2024 GM', text: 'ICD 10 Version 2024 GM', misdValue: '2024' },
          { value: '10 2023 GM', text: 'ICD 10 Version 2023 GM', misdValue: '2023' },
          { value: '10 2022 GM', text: 'ICD 10 Version 2022 GM', misdValue: '2022' },
          { value: '10 2021 GM', text: 'ICD 10 Version 2021 GM', misdValue: '2021' },
          { value: '10 2020 GM', text: 'ICD 10 Version 2020 GM', misdValue: '2020' },
          { value: '10 2019 GM', text: 'ICD 10 Version 2019 GM', misdValue: '2019' },
          { value: '10 2018 GM', text: 'ICD 10 Version 2018 GM', misdValue: '2018' },
          { value: '10 2017 GM', text: 'ICD 10 Version 2017 GM', misdValue: '2017' },
          { value: '10 2016 GM', text: 'ICD 10 Version 2016 GM', misdValue: '2016' },
          { value: '10 2015 GM', text: 'ICD 10 Version 2015 GM', misdValue: '2015' },
          { value: '10 2014 GM', text: 'ICD 10 Version 2014 GM', misdValue: '2014' },
          { value: '10 2013 GM', text: 'ICD 10 Version 2013 GM', misdValue: '2013' },
          { value: '10 2012 GM', text: 'ICD 10 Version 2012 GM', misdValue: '2012' },
          { value: '10 2011 GM', text: 'ICD 10 Version 2011 GM', misdValue: '2011' },
          { value: '10 2010 GM', text: 'ICD 10 Version 2010 GM', misdValue: '2010' },
          { value: '10 2009 GM', text: 'ICD 10 Version 2009 GM', misdValue: '2009' },
          { value: '10 2008 GM', text: 'ICD 10 Version 2008 GM', misdValue: '2008' },
          { value: '10 2007 GM', text: 'ICD 10 Version 2007 GM', misdValue: '2007' },
          { value: '10 2006 GM', text: 'ICD 10 Version 2006 GM', misdValue: '2006' },
          { value: '10 2005 GM', text: 'ICD 10 Version 2005 GM', misdValue: '2005' },
          { value: '10 2004 GM', text: 'ICD 10 Version 2004 GM', misdValue: '2004' },
          { value: 'Sonstige', text: 'Sonstige', misdValue: 'Sonstige' }
        ],
        PairedTumorList: ['C08.0', 'C08.1', 'C09.0', 'C09.1', 'C09.8', 'C09.9', 'C30.0', 'C30.1', 'C31.0', 'C31.2', 'C34.0', 'C34.1', 'C34.3', 'C34.8', 'C34.9', 'C38.4', 'C40.0', 'C40.1', 'C40.2', 'C40.3', 'C41.3', 'C41.4', 'C44.1', 'C44.2', 'C44.6', 'C44.7', 'C47.1', 'C47.2', 'C49.1', 'C49.2', 'C50.0', 'C50.1', 'C50.2', 'C50.3', 'C50.4', 'C50.5', 'C50.6', 'C50.8', 'C50.9', 'C57.0', 'C62.0', 'C62.1', 'C62.9', 'C63.0', 'C63.1', 'C69.0', 'C69.1', 'C69.2', 'C69.3', 'C69.4', 'C69.5', 'C69.6', 'C69.8', 'C69.9', 'C71.1', 'C71.2', 'C71.3', 'C71.4', 'C72.2', 'C72.3', 'C72.4', 'C74.0', 'C74.1', 'C74.9', 'C75.4'],
        PairedAdditionalTumors: {
          'C07': 'C07.9',
          'C43.1': 'C44.1',
          'C43.2': 'C44.2',
          'C43.6': 'C44.6',
          'C43.7': 'C44.7',
          'C56': 'C56.9',
          'C64': 'C64.9',
          'C65': 'C65.9',
          'C66': 'C66.9',
          'D05.0': 'C50.9',
          'D05.1': 'C50.9',
          'D05.7': 'C50.9',
          'D05.9': 'C50.9'
        },
        NotPairedAdditionalTumors: {
          'D09.0': 'C67.9'
        },
        Primaertumor_Topographie_ICD_O_VersionTypes: [
          { value: '33', text: 'ICD-O3, 2. Revision 2019', misdValue: 'Zweite Revision' },
          { value: '32', text: 'ICD-O3, 1. Revision 2014', misdValue: 'Erste Revision' }
        ],
        DiagnosesicherungTypes: [
          { value: '1', text: '1 - Klinisch ohne tumorspezifische Diagnostik (nur körperliche Untersuchung)' },
          { value: '2',
            text: '2 - Klinisch: Klinische Diagnose vor dem Sterbedatum durchgeführt',
            title: 'Schließt diagnostische Techniken, inklusive Röntgen, Endoskopie, weitere bildgebende Verfahren, Ultraschall, exploratorische Chirurgie (Laparatomie, etc.) und Autopsie, ohne mikroskopische Gewebediagnose, ein.'
          },
          { value: '4',  text: '4 - Spezifische Tumormarker' },
          { value: '5',
            text: '5 - Zytologisch',
            title: 'Untersuchung von Zellen aus primären Lokalisationen inklusive Flüssigkeitsaspirationen mittels Endoskopien oder Nadeln. Schließt mikroskopische Untersuchungen von peripheren Blutausstrichen und Ausstrichen von Beckenkammaspirationen ein.'
          },
          { value: '6', text: '6 - Histologie Metastase (Ausprägung ist veraltet, besser 7.2 nutzen)' },
          { value: '7',
            text: '7 - Histologisch: Histologie des Primärtumors (Ausprägung ist veraltet, besser 7.1 nutzen)'
          },
          {value: '7.1',
            text: '7.1 - Histologie des Primärtumors: Histologische Untersuchung von Gewebe des Primärtumors einschließlich aller Schnitttechniken und Knochenmarksbiopsien.'
          },
          { value: '7.2',
            text: '7.2 - Histologie Metastase: Histologische Untersuchung des Gewebes aus einer Metastase'
          },
          { value : '7.3',
            text: '7.3 - Histologie der Autopsie: Histologische Untersuchung des Gewebes bei einer Autopsie'
          },
          { value: '8', text: '8 - Zytogenetisch und/oder molekularer Test' },
          {value: '9',  text: '9 - Unbekannt' }
        ],
        SeitenlokalisationTypes: {
          L: 'Links',
          R: 'Rechts',
          B: 'Beidseitig (bei bestimmten Tumoren 2 Meldungen angeben)',
          M: 'Mittellinie/mittig',
          U: 'Unbekannt',
          T: 'Trifft nicht zu'
        },
        SeitenlokalisationTypesShort: {
          L: 'Links',
          R: 'Rechts',
          B: 'Beidseitig',
          M: 'Mittellinie/mittig',
          U: 'Unbekannt',
          T: 'Trifft nicht zu'
        },
        SeitenlokalisationTypesPairedTumors: {
          L: 'Links',
          R: 'Rechts',
          B: 'Beidseitig (bei bestimmten Tumoren 2 Meldungen angeben)',
          U: 'Unbekannt'
        },
        Morphologie_ICD_O_VersionTypes: [
          { value: '33', text: '33 - ICD-O-3, 2.Revision 2019', misdValue: 'Zweite Revision' },
          { value: '32', text: '32 - ICD-O-3, 1.Revision 2014', misdValue: 'Erste Revision' },
          { value: '31', text: '31 - ICD-O-3, 1.Auflage 2003', misdValue: 'Erste Auflage' }
        ],
        Morphologie_ICD_O_VersionTypes_from_lib: {
          'Zweite Revision': '33',
          'Erste Revision': '32',
          'Erste Auflage': '31'
        },
        GradingTypes: [
          { value: 'L', text: 'L - Low grade (G1 oder G2)' },
          { value: 'M', text: 'M - Intermediate (G2 oder G3)' },
          { value: 'H', text: 'H - High grade (G3 oder G4)' },
          { divider: true },
          { value: '0', text: '0 - Malignes Melanom der Konjunktiva' },
          { value: '1', text: '1 - Gut differenziert' },
          { value: '2', text: '2 - Mäßig differenziert' },
          { value: '3', text: '3 - Schlecht differenziert' },
          { value: '4', text: '4 - Undifferenziert' },
          { divider: true },
          { value: 'B', text: '8 - Borderline' },
          { value: 'X', text: 'X - Nicht bestimmbar' },
          { value: 'U', text: 'U - Unbekannt' },
          { value: 'T', text: 'T - Trifft nicht zu' }
        ],
        FM_LokalisationTypes: [
          { value: 'ADR', text: 'ADR - Nebennieren' },
          { value: 'BRA', text: 'BRA - Hirn' },
          { value: 'GEN', text: 'GEN - Generalisierte Metastasierung' },
          { value: 'HEP', text: 'HEP - Leber' },
          { value: 'LYM', text: 'LYM - Lymphknoten' },
          { value: 'MAR', text: 'MAR - Knochenmark' },
          { value: 'OSS', text: 'OSS - Knochen' },
          { value: 'OTH', text: 'OTH - Andere Organe' },
          { value: 'PER', text: 'PER - Peritoneum' },
          { value: 'PLE', text: 'PLE - Pleura' },
          { value: 'PUL', text: 'PUL - Lunge' },
          { value: 'SKI', text: 'SKI - Haut' }
        ],
        TNM_VersionTypes: [
          { value: '9', text: '9. Auflage (ab 2025)' },
          { value: '8', text: '8. Auflage (2017 -2025)' },
          { value: '7', text: '7. Auflage (2010 - 2016)' },
          { value: '6', text: '6. Auflage (2003 - 2009)' }
        ],
        TNM_TTypes: [
          { value: '0', text: '0' },
          { value: 'X', text: 'X' },
          { value: 'a', text: 'a' },
          { value: '1', text: '1' },
          { value: '1a', text: '1a' },
          { value: '1a1', text: '1a1' },
          { value: '1a2', text: '1a2' },
          { value: '1b', text: '1b' },
          { value: '1b1', text: '1b1' },
          { value: '1b2', text: '1b2' },
          { value: '1c', text: '1c' },
          { value: '1d', text: '1d' },
          { value: '1mi', text: '1mi' },
          { value: '2', text: '2' },
          { value: '2a', text: '2a' },
          { value: '2a1', text: '2a1' },
          { value: '2a2', text: '2a2' },
          { value: '2b', text: '2b' },
          { value: '2c', text: '2c' },
          { value: '2d', text: '2d' },
          { value: '3', text: '3' },
          { value: '3a', text: '3a' },
          { value: '3b', text: '3b' },
          { value: '3c', text: '3c' },
          { value: '3d', text: '3d' },
          { value: '4', text: '4' },
          { value: '4a', text: '4a' },
          { value: '4b', text: '4b' },
          { value: '4c', text: '4c' },
          { value: '4d', text: '4d' },
          { value: '4e', text: '4e' },
          { value: 'is', text: 'is' },
          { value: 'is(DCIS)', text: 'is(DCIS)' },
          { value: 'is(LCIS)', text: 'is(LCIS)' },
          { value: 'is(Paget)', text: 'is(Paget)' },
          { value: 'is(pd)', text: 'is(pd)' },
          { value: 'is(pu)', text: 'is(pu)' }
        ],
        TNM_NTypes: [
          { value: '0', text: '0' },
          { value: '0(i+)', text: '0(i+)' },
          { value: '0(i-)', text: '0(i-)' },
          { value: '0(mol+)', text: '0(mol+)' },
          { value: '0(mol-)', text: '0(mol-)' },
          { value: '1', text: '1' },
          { value: '1a', text: '1a' },
          { value: '1b', text: '1b' },
          { value: '1c', text: '1c' },
          { value: '1mi', text: '1mi' },
          { value: '1(sn)', text: '1(sn)' },
          { value: '1a(sn)', text: '1a(sn)' },
          { value: '2', text: '2' },
          { value: '2a', text: '2a' },
          { value: '2b', text: '2b' },
          { value: '2c', text: '2c' },
          { value: '3', text: '3' },
          { value: '3a', text: '3a' },
          { value: '3b', text: '3b' },
          { value: '3c', text: '3c' },
          { value: 'X', text: 'X' }
        ],
        TNM_MTypes: [
          { value: '0', text: '0' },
          { value: '0(i+)', text: '0(i+)' },
          { value: '0(i-)', text: '0(i-)' },
          { value: '0(mol+)', text: '0(mol+)' },
          { value: '0(mol-)', text: '0(mol-)' },
          { value: '1', text: '1' },
          { value: '1a', text: '1a' },
          { value: '1b', text: '1b' },
          { value: '1c', text: '1c' },
          { value: '1d', text: '1d' },
          { value: '1e', text: '1e' },
          { value: 'X', text: 'X' }
        ],
        TNM_MSymbolTypes: [
          { value: 'm', text: 'm' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' }
        ],
        TNM_LTypes: [
          { value: 'LX', text: 'LX - Lymphgefäßinvasion kann nicht beurteilt werden' },
          { value: 'L0', text: 'L0 - Keine Lymphgefäßinvasion' },
          { value: 'L1', text: 'L1 - Lymphgefäßinvasion' }
        ],
        TNM_VTypes: [
          { value: 'VX', text: 'VX - Veneninvasion kann nicht beurteilt werden' },
          { value: 'V0', text: 'V0 - Keine Veneninvasion' },
          { value: 'V1', text: 'V1 - Mikroskopische Veneninvasion' },
          { value: 'V2', text: 'V2 - Makroskopische Veneninvasion' }
        ],
        TNM_PnTypes: [
          { value: 'PnX', text: 'PnX - Perineurale Invasion kann nicht beurteilt werden' },
          { value: 'Pn0', text: 'Pn0 - Keine perineurale Invasion' },
          { value: 'Pn1', text: 'Pn1 - Perineurale Invasion' }
        ],
        TNM_STypes: [
          { value: 'SX', text: 'SX - Serumtumormarker sind nicht vorhanden oder wurden nicht bestimmt' },
          { value: 'S0', text: 'S0 - Tumormarker sind im angegebenen Normbereich' },
          { value: 'S1', text: 'S1 - LDH <1.5 x N und hCG (mIu/mL) <5000 und AFP (ng/mL) <1000' },
          { value: 'S2', text: 'S2 - LDH 1.5-10 x N oder hCG (mIu/mL) 5000-50,000 oder AFP (ng/mL) 1000-10,000' },
          { value: 'S3', text: 'S3 - LDH >10 x N oder hCG (mIu/mL) >50,000 oder AFP (ng/mL) >10,000' }
        ],
        UICC_StadiumTypes: [
          { value: 'okk', text: 'okk' },
          { value: '0', text: '0' },
          { value: '0a', text: '0a' },
          { value: '0is', text: '0is' },
          { value: 'I', text: 'I' },
          { value: 'IA', text: 'IA' },
          { value: 'IA1', text: 'IA1' },
          { value: 'IA2', text: 'IA2' },
          { value: 'IA3', text: 'IA3' },
          { value: 'IB', text: 'IB' },
          { value: 'IB1', text: 'IB1' },
          { value: 'IB2', text: 'IB2' },
          { value: 'IC', text: 'IC' },
          { value: 'II', text: 'II' },
          { value: 'IIA', text: 'IIA' },
          { value: 'IIA1', text: 'IIA1' },
          { value: 'IIA2', text: 'IIA2' },
          { value: 'IIB', text: 'IIB' },
          { value: 'IIC', text: 'IIC' },
          { value: 'III', text: 'III' },
          { value: 'IIIA', text: 'IIIA' },
          { value: 'IIIA1', text: 'IIIA1' },
          { value: 'IIIA2', text: 'IIIA2' },
          { value: 'IIIB', text: 'IIIB' },
          { value: 'IIIC', text: 'IIIC' },
          { value: 'IIIC1', text: 'IIIC1' },
          { value: 'IIIC2', text: 'IIIC2' },
          { value: 'IIID', text: 'IIID' },
          { value: 'IS', text: 'IS' },
          { value: 'IV', text: 'IV' },
          { value: 'IVA', text: 'IVA' },
          { value: 'IVA1', text: 'IVA1' },
          { value: 'IVA2', text: 'IVA2' },
          { value: 'IVB', text: 'IVB' },
          { value: 'IVC', text: 'IVC' }
        ],
        ecogArray: [
          { value: null, text: '' },
          { value: '0', text: '0 - Normale, uneingeschränkte Aktivität wie vor der Erkrankung (90 - 100 % nach Karnofsky)' },
          { value: '1', text: '1 - Einschränkung bei körperlicher Anstrengung, aber gehfähig; leichte körperliche Arbeit bzw. Arbeit im Sitzen (z.B. leichte Hausarbeit oder Büroarbeit) möglich (70 - 80 % nach Karnofsky)' },
          { value: '2', text: '2 - Gehfähig, Selbstversorgung möglich, aber nicht arbeitsfähig; kann mehr als 50% der Wachzeit aufstehen (50 - 60 % nach Karnofsky)' },
          { value: '3', text: '3 - Nur begrenzte Selbstversorgung möglich; ist 50% oder mehr der Wachzeit an Bett oder Stuhl gebunden (30 - 40 % nach Karnofsky)' },
          { value: '4', text: '4 - Völlig pflegebedürftig, keinerlei Selbstversorgung möglich; völlig an Bett oder Stuhl gebunden (10 - 20% nach Karnofsky)' }
        ],
        karnofskyArray: [
          { value: null, text: '' },
          { value: '10', text: '10' },
          { value: '20', text: '20' },
          { value: '30', text: '30' },
          { value: '40', text: '40' },
          { value: '50', text: '50' },
          { value: '60', text: '60' },
          { value: '70', text: '70' },
          { value: '80', text: '80' },
          { value: '90', text: '90' },
          { value: '100', text: '100' }
        ],
        GleasonGradPrimaerTypes: ['1', '2', '3', '4', '5'],
        GleasonGradSekundaerTypes: ['1', '2', '3', '4', '5'],
        GleasonScoreErgebnisTypes: ['2', '3', '4', '5', '6', '7', '7a', '7b', '8', '9', '10'],
        TumorStatusGeneralTypes: [
          { value: 'V_new', text: 'V - Erstmalige Vollremission (complete remission, CR)', short: 'Erstmalige Vollremission' },
          { value: 'V_cont', text: 'W - Weiterhin bestehende Vollremission (complete remission, CR)', short: 'Vollremission' },
          { value: 'T', text: 'T - Teilremission / mindestens 50% Rückgang des Tumors (partial remission, PR)', short: 'Teilremission' },
          { value: 'K', text: 'K - Keine Änderung (no change, NC) = stable disease', short: 'Keine Änderung' },
          { value: 'P', text: 'P - Progression', short: 'Progression' },
          { value: 'D', text: 'D - Divergentes Geschehen', short: 'Divergentes Geschehen' },
          { value: 'B', text: 'B - Klinische Besserung des Zustandes, Kriterien für Teilremission jedoch nicht erfüllt (minimal response, MR)', short: 'Klinische Besserung des Zustandes, Kriterien für Teilremission jedoch nicht erfüllt' },
          { value: 'R', text: 'R - Vollremission mit residualen Auffälligkeiten (CRr)', short: 'Vollremission mit residualen Auffälligkeiten' },
          { value: 'Y', text: 'Y - Rezidiv', short: 'Rezidiv' },
          { value: 'U', text: 'U - Beurteilung unmöglich', short: 'Beurteilung unmöglich' },
          { value: 'X', text: 'X - Fehlende Angaben', short: 'Fehlende Angaben' }
        ],
        TumorStatusGeneralTypesImport: [
          { value: 'V_new', text: 'V - Erstmalige Vollremission (complete remission, CR)', short: 'Erstmalige Vollremission' },
          { value: 'T', text: 'T - Teilremission / mindestens 50% Rückgang des Tumors (partial remission, PR)', short: 'Teilremission' },
          { value: 'P', text: 'P - Progression', short: 'Progression' },
          { value: 'D', text: 'D - Divergentes Geschehen', short: 'Divergentes Geschehen' },
          { value: 'B', text: 'B - Klinische Besserung des Zustandes, Kriterien für Teilremission jedoch nicht erfüllt (minimal response, MR)', short: 'Klinische Besserung des Zustandes, Kriterien für Teilremission jedoch nicht erfüllt' },
          { value: 'R', text: 'R - Vollremission mit residualen Auffälligkeiten (CRr)', short: 'Vollremission mit residualen Auffälligkeiten' },
          { value: 'Y', text: 'Y - Rezidiv', short: 'Rezidiv' },
          { value: 'U', text: 'U - Beurteilung unmöglich', short: 'Beurteilung unmöglich' },
          { value: 'X', text: 'X - Fehlende Angaben', short: 'Fehlende Angaben' }
        ],
        TumorStatusLokalTypes: [
          { value: 'K', text: 'K - Kein Tumor nachweisbar' },
          { value: 'T', text: 'T - Tumorreste (Residualtumor)' },
          { value: 'P', text: 'P - Tumorreste Residualtumor Progress' },
          { value: 'N', text: 'N - Tumorreste Residualtumor No Change' },
          { value: 'R', text: 'R - Lokalrezidiv' },
          { value: 'F', text: 'F - Fraglicher Befund' },
          { value: 'U', text: 'U - Unbekannt' },
          { value: 'X', text: 'X - Fehlende Angabe' }
        ],
        TumorStatusLymphNodesTypes: [
          { value: 'K', text: 'K - Kein Lymphknotenbefall nachweisbar' },
          { value: 'T', text: 'T - Bekannter Lymphknotenbefall Residuen' },
          { value: 'P', text: 'P - Bekannter Lymphknotenbefall Progress' },
          { value: 'N', text: 'N - Bekannter Lymphknotenbefall No Change' },
          { value: 'R', text: 'R - Neu aufgetretenes Lymphknotenrezidiv' },
          { value: 'F', text: 'F - Fraglicher Befund' },
          { value: 'U', text: 'U - Unbekannt' },
          { value: 'X', text: 'X - Fehlende Angabe' }
        ],
        TumorStatusMetastasesTypes: [
          { value: 'K', text: 'K - Keine Fernmetastasen nachweisbar' },
          { value: 'T', text: 'T - Fernmetastasen Residuen' },
          { value: 'P', text: 'P - Fernmetastasen Progress' },
          { value: 'N', text: 'N - Fernmetastasen No Change' },
          { value: 'R', text: 'R - Neu aufgetretene Fernmetastase(n) bzw. Metastasenrezidiv' },
          { value: 'F', text: 'F - Fraglicher Befund' },
          { value: 'U', text: 'U - Unbekannt' },
          { value: 'X', text: 'X - Fehlende Angabe' }
        ],
        OP_IntentionTypes: {
          K: {
            text: 'K - Kurativ',
            title: 'Eingriff zur Tumorentfernung (den Tumor resezierende OPs UND Nachresektionen, kurative Metastasenentfernung), mit Ausnahme ablativer/Destruktiver Verfahren (zb Thermoablation, TUR-B). Hier ist ein R-lokal erwartbar und erforderlich. Das R-lokal kann sich auch auf eine Metastasenresektion beziehen.'
          },
          P: {
            text: 'P - Palliativ',
            title: 'Eingriffe mit Tumor-(Teil-)-Entfernung, z.B. sog. Debulking-OP, lokale Tumorresektion trotz (weiterer) Fernmetastase. Ein R-Lokal sollte vergeben werden.'
          },
          D: {
            text: 'D - Diagnostisch',
            title: 'Eingriff, der i.d.R. zur Feststellung der Morphologie und/oder des Stadiums des Tumors benötigt wird. Eine Tumor-Resektion ist hier nicht das Ziel, also R nicht plausibel, da hier eigentlich immer davon ausgegangen werden muss, dass der Tumor noch da ist. Diese mit R2 zu bezeichnen wäre unklinisch. Schwerpunkt liegt hier in der Angabe und Findung einer spezifischen Histologie bzw. eines cTNM.'
          },
          R: {
            text: 'R - Revision/Komplikation',
            title: 'Operation oder Re-Operation, die zur Behebung einer Komplikation im Zusammenhang mit der Tumortherapie notwendig ist und nicht der Tumorresektion (Nachresektion) dient. Ein R ist hier klinisch nicht plausibel.'
          },
          S: {
            text: 'S - Sonstiges',
            title: 'Eingriffe ohne Tumorentfernung, die jedoch in direktem Zusammenhang mit der Erkrankung stehen/ zum Therapiekonzept gehören. Das sind z.B. Stabilitätsoperationen bei Knochentumoren, Portimplantationen oder auch AP-Rückverlagerungen. Da kein Tumor entfernt wird, kann es auch keine R-Angabe geben.'
          },
          X: {
            text: 'X - Fehlende Angabe',
            title: 'Ist zu vermeiden und allenfalls akzeptabel, wenn es sich um die Meldung einer Leistung handelt, die nicht selbst durchgeführt wurde'
          }
        },
        OP_OPS_VersionTypes: [
          { value: '2026', text: 'Version 2026', misdValue: '2026' },
          { value: '2025', text: 'Version 2025', misdValue: '2025' },
          { value: '2024', text: 'Version 2024', misdValue: '2024' },
          { value: '2023', text: 'Version 2023', misdValue: '2023' },
          { value: '2022', text: 'Version 2022', misdValue: '2022' },
          { value: '2021', text: 'Version 2021', misdValue: '2021' },
          { value: '2020', text: 'Version 2020', misdValue: '2020' },
          { value: '2019', text: 'Version 2019', misdValue: '2019' },
          { value: '2018', text: 'Version 2018', misdValue: '2018' },
          { value: '2017', text: 'Version 2017', misdValue: '2017' },
          { value: '2016', text: 'Version 2016', misdValue: '2016' },
          { value: '2015', text: 'Version 2015', misdValue: '2015' },
          { value: '2014', text: 'Version 2014', misdValue: '2014' },
          { value: '2013', text: 'Version 2013', misdValue: '2013' },
          { value: '2012', text: 'Version 2012', misdValue: '2012' },
          { value: '2011', text: 'Version 2011', misdValue: '2011' },
          { value: '2010', text: 'Version 2010', misdValue: '2010' },
          { value: '2009', text: 'Version 2009', misdValue: '2009' },
          { value: '2008', text: 'Version 2008', misdValue: '2008' },
          { value: '2007', text: 'Version 2007', misdValue: '2007' },
          { value: '2006', text: 'Version 2006', misdValue: '2006' },
          { value: '2005', text: 'Version 2005', misdValue: '2005' },
          { value: '2004', text: 'Version 2004', misdValue: '2004' }
        ],
        ResidualstatusTypes: [
          { value: 'R0', text: 'R0 - Kein Residualtumor' },
          { value: 'R1', text: 'R1 - Mikroskopischer Residualtumor' },
          { value: 'R1(is)', text: 'R1(is) - In-Situ-Rest' },
          { value: 'R1(cy+)', text: 'R1(cy+) - Cytologischer Rest' },
          { value: 'R2', text: 'R2 - Makroskopischer Residualtumor' },
          { value: 'RX', text: 'RX - Vorhandensein von Residualtumor kann nicht beurteilt werden' },
          { value: 'U', text: 'U - Residualtumorstatus ist nicht bekannt' }
        ],
        OP_KomplikationTypes: [
          { value: 'abd', text: 'ABD - Abszeß in einem Drainagekanal' },
          { value: 'abs', text: 'ABS - Abszeß, intraabdominaler oder intrathorakaler' },
          { value: 'asf', text: 'ASF - Abszeß, subfaszialer' },
          { value: 'ani', text: 'ANI - Akute Niereninsuffizienz' },
          { value: 'aep', text: 'AEP - Alkoholentzugspsychose' },
          { value: 'alr', text: 'ALR - Allergische Reaktion ohne Schocksymptomatik' },
          { value: 'ans', text: 'ANS - Anaphylaktischer Schock' },
          { value: 'aee', text: 'AEE - Anastomoseninsuffizienz einer Enterostomie' },
          { value: 'api', text: 'API - Apoplektischer Insult' },
          { value: 'bif', text: 'BIF - Biliäre Fistel' },
          { value: 'bog', text: 'BOG - Blutung, obere gastrointestinale (z.B Stressulkus)' },
          { value: 'boe', text: 'BOE - Bolusverlegung eines Endotubus' },
          { value: 'bsi', text: 'BSI - Bronchusstumpfinsuffizienz' },
          { value: 'chi', text: 'CHI - Cholangitis' },
          { value: 'dai', text: 'DAI - Darmanastomoseinsuffizienz' },
          { value: 'dps', text: 'DPS - Darmpassagestörungen (z.B. protrahierte Atonie, Subileus, Ileus)' },
          { value: 'dic', text: 'DIC - Disseminierte intravasale Koagulopathie' },
          { value: 'dep', text: 'DEP - Drogenentzugspsychose' },
          { value: 'dlu', text: 'DLU - Druck- und Lagerungsschäden, z.B. Dekubitalulzera' },
          { value: 'dsi', text: 'DSI - Duodenalstumpfinsuffizienz' },
          { value: 'enf', text: 'ENF - Enterale Fistel' },
          { value: 'ger', text: 'GER - Gerinnungsstörung' },
          { value: 'hem', text: 'HEM - Hämatemesis' },
          { value: 'hur', text: 'HUR - Hämaturie' },
          { value: 'hae', text: 'HAE - Hämorrhagischer Schock' },
          { value: 'hfi', text: 'HFI - Harnfistel' },
          { value: 'hnk', text: 'HNK - Hautnekrose im Operationsbereich' },
          { value: 'hzi', text: 'HZI - Herzinsuffizienz' },
          { value: 'hrs', text: 'HRS - Herzrhythmusstörungen' },
          { value: 'hna', text: 'HNA - Hirnnervenausfälle' },
          { value: 'hop', text: 'HOP - Hirnorganisches Psychosyndrom (z.B. Durchgangssyndrom)' },
          { value: 'hyb', text: 'HYB - Hyperbilirubinämie' },
          { value: 'hyf', text: 'HYF - Hypopharynxfistel' },
          { value: 'ifv', text: 'IFV - Ileofemorale Venenthrombose' },
          { value: 'kas', text: 'KAS - Kardiogener Schock' },
          { value: 'kes', text: 'KES - Komplikationen einer Stomaanlage' },
          { value: 'kim', text: 'KIM - Komplikation eines Implantates (Gefäßprothese, Totalendoprothese, Katheter), z.B. Dislokation' },
          { value: 'kra', text: 'KRA - Krampfanfall' },
          { value: 'kds', text: 'KDS - Kurzdarmsyndrom' },
          { value: 'lev', text: 'LEV - Leberversagen' },
          { value: 'loe', text: 'LOE - Lungenödem' },
          { value: 'lyf', text: 'LYF - Lymphfistel' },
          { value: 'lye', text: 'LYE - Lymphozele' },
          { value: 'mes', text: 'MES - Magenentleerungsstörung' },
          { value: 'mil', text: 'MIL - Mechanischer Ileus' },
          { value: 'med', text: 'MED - Mediastinitis' },
          { value: 'mat', text: 'MAT - Mesenterialarterien- oder -venenthrombose' },
          { value: 'myi', text: 'MYI - Myokardinfarkt' },
          { value: 'rnb', text: 'RNB - Nachblutung, revisionsbedürftig, anderweitig nicht erwähnt' },
          { value: 'nab', text: 'NAB - Nachblutung, nicht revisionsbedürftig, anderweitig nicht erwähnt' },
          { value: 'nin', text: 'NIN - Nahtinsuffizienz, anderweitig nicht erwähnt' },
          { value: 'oes', text: 'OES - Ösophagitis' },
          { value: 'osm', text: 'OSM - Osteitis, Osteomyelitis' },
          { value: 'paf', text: 'PAF - Pankreasfistel' },
          { value: 'pit', text: 'PIT - Pankreatitis' },
          { value: 'pab', text: 'PAB - Peranale Blutung' },
          { value: 'ppa', text: 'PPA - Periphere Parese ' },
          { value: 'pav', text: 'PAV - Peripherer arterieller Verschluß (Embolie, Thrombose)' },
          { value: 'per', text: 'PER - Peritonitis' },
          { value: 'plb', text: 'PLB - Platzbauch' },
          { value: 'pey', text: 'PEY - Pleuraempyem' },
          { value: 'ple', text: 'PLE - Pleuraerguß' },
          { value: 'pmn', text: 'PMN - Pneumonie' },
          { value: 'pnt', text: 'PNT - Pneumothorax' },
          { value: 'pda', text: 'PDA - Protrahierte Darmatonie (paralytischer Ileus)' },
          { value: 'pae', text: 'PAE - Pulmonalarterienembolie' },
          { value: 'rpa', text: 'RPA - Rekurrensparese' },
          { value: 'rin', text: 'RIN - Respiratorische Insuffizienz' },
          { value: 'ski', text: 'SKI - Septische Komplikation eines Implantates' },
          { value: 'ses', text: 'SES - Septischer Schock' },
          { value: 'sfh', text: 'SFH - Störungen des Flüssigkeits-, Elektrolyt- und Säurebasenhaushaltes' },
          { value: 'stk', text: 'STK - Stomakomplikation (z.B. Blutung, Nekrose, Stenose)' },
          { value: 'tzp', text: 'TZP - Thrombozytopenie' },
          { value: 'tia', text: 'TIA - TIA oder RIND' },
          { value: 'trz', text: 'TRZ - Transfusionszwischenfall' },
          { value: 'wuh', text: 'WUH - Wundhämatom (konservativ therapiert)' },
          { value: 'wss', text: 'WSS - Wundheilungsstörung, subkutane' }
        ],
        Nebenwirkung_GradTypes: [
          { value: '3', text: '3 - Stark/ausgeprägt' },
          { value: '4', text: '4 - Lebensbedrohlich' },
          { value: '5', text: '5 - Tödlich' }
        ],
        Nebenwirkung_VersionTypes: [
          { value: '5.0', text: 'CTCAE Version 5.0' },
          { value: '4.03', text: 'CTCAE Version 4.03' },
          { value: '4', text: 'CTCAE Version 4' },
          { value: 'Sonstige', text: 'Sonstige - Falls andere bzw. ältere Versionen verwendet werden' }
        ],
        ST_IntentionTypes: [
          { value: 'K', text: 'Kurativ' },
          { value: 'P', text: 'Palliativ' },
          { value: 'O', text: 'Lokal kurativ bei Oligometastasierung' },
          { value: 'S', text: 'Sonstiges' },
          { value: 'X', text: 'Keine Angabe' }
        ],
        ST_Stellung_OPTypes: [
          { value: 'O', text: 'Ohne Bezug' },
          { value: 'A', text: 'Adjuvant' },
          { value: 'N', text: 'Neoadjuvant' },
          { value: 'I', text: 'Intraoperativ' },
          { value: 'Z', text: 'Additiv' },
          { value: 'S', text: 'Sonstiges' }
        ],
        ST_Ende_GrundTypes: [
          { value: 'A', text: 'Abbruch wegen Nebenwirkungen' },
          { value: 'E', text: 'Reguläres Ende' },
          { value: 'F', text: 'Zieldosis erreicht mit Unterbrechung > 3 Kalendertage' },
          { value: 'V', text: 'Patient verweigert weitere Therapie' },
          { value: 'P', text: 'Abbruch wegen Progress' },
          { value: 'S', text: 'Abbruch aus sonstigen Gründen' },
          { value: 'T', text: 'Patient verstorben' },
          { value: 'U', text: 'Unbekannt' }
        ],
        // oBDS_Zielgebiet2014_Typ
        ST_ZielgebietTypes2014: [
          { header: 'ZNS' },
          { value: '1.', text: '1. ZNS', short: 'ZNS' },
          { value: '1.1.', text: '1.1. Ganzhirn', short: 'Ganzhirn' },
          { value: '1.2.', text: '1.2. Teilhirn', short: 'Teilhirn' },
          { value: '1.3.', text: '1.3. Neuroachse', short: 'Neuroachse' },
          { header: 'Kopf-Hals mit/ ohne Lymphknotenregion' },
          { value: '2.', text: '2. Kopf-Hals mit/ ohne Lymphknotenregion', short: 'Kopf-Hals mit/ ohne Lymphknotenregion' },
          { value: '2.+', text: '2.+ Kopf-Hals mit Lymphknotenregion', short: 'Kopf-Hals mit Lymphknotenregion' },
          { value: '2.-', text: '2.- Kopf-Hals ohne Lymphknotenregion', short: 'Kopf-Hals ohne Lymphknotenregion' },
          { value: '2.1.', text: '2.1. Orbita, o.n.A', short: 'Orbita' },
          { value: '2.1.+', text: '2.1.+ Orbita (mit Lymphknotenregion)', short: 'Orbita (mit Lymphknotenregion)' },
          { value: '2.1.-', text: '2.1.- Orbita (ohne Lymphknotenregion)', short: 'Orbita (ohne Lymphknotenregion)' },
          { value: '2.2.', text: '2.2. Nase/Nasennebenhöhle, o. n. A.', short: 'Nase/Nasennebenhöhle' },
          { value: '2.2.+', text: '2.2.+ Nase/Nasennebenhöhle (mit Lymphknotenregion)', short: 'Nase/Nasennebenhöhle (mit Lymphknotenregion)' },
          { value: '2.2.-', text: '2.2.- Nase/Nasennebenhöhle (ohne Lymphknotenregion)', short: 'Nase/Nasennebenhöhle (ohne Lymphknotenregion)' },
          { value: '2.3.', text: '2.3. Mundhöhle, o. n. A.', short: 'Mundhöhle' },
          { value: '2.3.+', text: '2.3.+ Mundhöhle (mit Lymphknotenregion)', short: 'Mundhöhle (mit Lymphknotenregion)' },
          { value: '2.3.-', text: '2.3.- Mundhöhle (ohne Lymphknotenregion)', short: 'Mundhöhle (ohne Lymphknotenregion)' },
          { value: '2.4.', text: '2.4. Ohr, o. n. A.', short: 'Ohr' },
          { value: '2.4.+', text: '2.4.+ Ohr (mit Lymphknotenregion)', short: 'Ohr (mit Lymphknotenregion)' },
          { value: '2.4.-', text: '2.4.- Ohr (ohne Lymphknotenregion)', short: 'Ohr (ohne Lymphknotenregion)' },
          { value: '2.5.', text: '2.5. Speicheldrüse, o. n. A.', short: 'Speicheldrüse' },
          { value: '2.5.+', text: '2.5.+ Speicheldrüse (mit Lymphknotenregion)', short: 'Speicheldrüse (mit Lymphknotenregion)' },
          { value: '2.5.-', text: '2.5.- Speicheldrüse (ohne Lymphknotenregion)', short: 'Speicheldrüse (ohne Lymphknotenregion)' },
          { value: '2.6.', text: '2.6. Pharynx, o. n. A.', short: 'Pharynx' },
          { value: '2.6.+', text: '2.6.+ Pharynx (mit Lymphknotenregion)', short: 'Pharynx (mit Lymphknotenregion)' },
          { value: '2.6.-', text: '2.6.- Pharynx (ohne Lymphknotenregion)', short: 'Pharynx (ohne Lymphknotenregion)' },
          { value: '2.7.', text: '2.7. Larynx, o. n. A.', short: 'Larynx' },
          { value: '2.7.+', text: '2.7.+ Larynx (mit Lymphknotenregion)', short: 'Larynx (mit Lymphknotenregion)' },
          { value: '2.7.-', text: '2.7.- Larynx (ohne Lymphknotenregion)', short: 'Larynx (ohne Lymphknotenregion)' },
          { value: '2.8.', text: '2.8. Schilddrüse, o. n. A.', short: 'Schilddrüse' },
          { value: '2.8.+', text: '2.8.+ Schilddrüse (mit Lymphknotenregion)', short: 'Schilddrüse (mit Lymphknotenregion)' },
          { value: '2.8.-', text: '2.8.- Schilddrüse (ohne Lymphknotenregion)', short: 'Schilddrüse (ohne Lymphknotenregion)' },
          { value: '2.9.', text: '2.9. Halslymphknoten (also ohne Primärtumor)', short: 'Halslymphknoten (also ohne Primärtumor)' },
          { header: 'Thorax mit /ohne Lymphknotenregion' },
          { value: '3.', text: '3. Thorax mit /ohne Lymphknotenregion', short: 'Thorax mit /ohne Lymphknotenregion' },
          { value: '3.+', text: '3.+ Thorax mit Lymphknotenregion', short: 'Thorax mit Lymphknotenregion' },
          { value: '3.-', text: '3.- Thorax ohne Lymphknotenregion', short: 'Thorax ohne Lymphknotenregion' },
          { value: '3.1.', text: '3.1. Mamma als Ganzbrust, o. n. A.', short: 'Mamma als Ganzbrust' },
          { value: '3.1.+', text: '3.1.+ Mamma als Ganzbrust (mit Lymphknotenregion)', short: 'Mamma als Ganzbrust (mit Lymphknotenregion)' },
          { value: '3.1.-', text: '3.1.- Mamma als Ganzbrust (ohne Lymphknotenregion)', short: 'Mamma als Ganzbrust (ohne Lymphknotenregion)' },
          { value: '3.2.', text: '3.2. Mamma als Teilbrust, o. n. A.', short: 'Mamma als Teilbrust' },
          { value: '3.2.+', text: '3.2.+ Mamma als Teilbrust (mit Lymphknotenregion)', short: 'Mamma als Teilbrust (mit Lymphknotenregion)' },
          { value: '3.2.-', text: '3.2.- Mamma als Teilbrust (ohne Lymphknotenregion)', short: 'Mamma als Teilbrust (ohne Lymphknotenregion)' },
          { value: '3.3.', text: '3.3. Brustwand (z.B. Rezidiven n. Ablatio Sarkome)', short: 'Brustwand (z.B. Rezidiven n. Ablatio Sarkome)' },
          { value: '3.3.+', text: '3.3.+ Brustwand (z.B. Rezidiven n. Ablatio Sarkome) (mit Lymphknotenregion)', short: 'Brustwand (z.B. Rezidiven n. Ablatio Sarkome) (mit Lymphknotenregion)' },
          { value: '3.3.-', text: '3.3.- Brustwand (z.B. Rezidiven n. Ablatio Sarkome) (ohne Lymphknotenregion)', short: 'Brustwand (z.B. Rezidiven n. Ablatio Sarkome) (ohne Lymphknotenregion)' },
          { value: '3.4.', text: '3.4. Lunge, o. n. A.', short: 'Lunge' },
          { value: '3.4.+', text: '3.4.+ Lunge (mit Lymphknotenregion)', short: 'Lunge (mit Lymphknotenregion)' },
          { value: '3.4.-', text: '3.4.- Lunge (ohne Lymphknotenregion)', short: 'Lunge (ohne Lymphknotenregion)' },
          { value: '3.5.', text: '3.5. Ösophagus, o. n. A.', short: 'Ösophagus' },
          { value: '3.5.+', text: '3.5.+ Ösophagus (mit Lymphknotenregion)', short: 'Ösophagus (mit Lymphknotenregion)' },
          { value: '3.5.-', text: '3.5.- Ösophagus (ohne Lymphknotenregion)', short: 'Ösophagus (ohne Lymphknotenregion)' },
          { value: '3.6.', text: '3.6. Thymus, o. n. A.', short: 'Thymus' },
          { value: '3.6.+', text: '3.6.+ Thymus (mit Lymphknotenregion)', short: 'Thymus (mit Lymphknotenregion)' },
          { value: '3.6.-', text: '3.6.- Thymus (ohne Lymphknotenregion)', short: 'Thymus (ohne Lymphknotenregion)' },
          { value: '3.7.', text: '3.7. Mediastinale Lymphknoten (also ohne Primärtumor)', short: 'Mediastinale Lymphknoten (also ohne Primärtumor)' },
          { header: 'Abdomen (ohne Becken) mit /ohne Lymphknotenregion' },
          { value: '4.', text: '4. Abdomen (ohne Becken) mit /ohne Lymphknotenregion', short: 'Abdomen (ohne Becken) mit /ohne Lymphknotenregion' },
          { value: '4.+', text: '4.+ Abdomen (ohne Becken) mit Lymphknotenregion', short: 'Abdomen (ohne Becken) mit Lymphknotenregion' },
          { value: '4.-', text: '4.- Abdomen (ohne Becken) ohne Lymphknotenregion', short: 'Abdomen (ohne Becken) ohne Lymphknotenregion' },
          { value: '4.1.', text: '4.1. Magen, o. n. A.', short: 'Magen' },
          { value: '4.1.+', text: '4.1.+ Magen (mit Lymphknotenregion)', short: 'Magen (mit Lymphknotenregion)' },
          { value: '4.1.-', text: '4.1.- Magen (ohne Lymphknotenregion)', short: 'Magen (ohne Lymphknotenregion)' },
          { value: '4.2.', text: '4.2. Pankreas, o. n. A.', short: 'Pankreas' },
          { value: '4.2.+', text: '4.2.+ Pankreas (mit Lymphknotenregion)', short: 'Pankreas (mit Lymphknotenregion)' },
          { value: '4.2.-', text: '4.2.- Pankreas (ohne Lymphknotenregion)', short: 'Pankreas (ohne Lymphknotenregion)' },
          { value: '4.3.', text: '4.3. Leber, o. n. A.', short: 'Leber' },
          { value: '4.3.+', text: '4.3.+ Leber (mit Lymphknotenregion)', short: 'Leber (mit Lymphknotenregion)' },
          { value: '4.3.-', text: '4.3.- Leber (ohne Lymphknotenregion)', short: 'Leber (ohne Lymphknotenregion)' },
          { value: '4.4.', text: '4.4. Milz, o. n. A.', short: 'Milz' },
          { value: '4.4.+', text: '4.4.+ Milz (mit Lymphknotenregion)', short: 'Milz (mit Lymphknotenregion)' },
          { value: '4.4.-', text: '4.4.- Milz (ohne Lymphknotenregion)', short: 'Milz (ohne Lymphknotenregion)' },
          { value: '4.5.', text: '4.5. Niere, o. n. A.', short: 'Niere' },
          { value: '4.5.+', text: '4.5.+ Niere (mit Lymphknotenregion)', short: ' Niere (mit Lymphknotenregion)' },
          { value: '4.5.-', text: '4.5.- Niere (ohne Lymphknotenregion)', short: 'Niere (ohne Lymphknotenregion)' },
          { value: '4.6.', text: '4.6. Nebenniere, o. n. A.', short: 'Nebenniere' },
          { value: '4.6.+', text: '4.6.+ Nebenniere (mit Lymphknotenregion)', short: 'Nebenniere (mit Lymphknotenregion)' },
          { value: '4.6.-', text: '4.6.- Nebenniere (ohne Lymphknotenregion)', short: 'Nebenniere (ohne Lymphknotenregion)' },
          { value: '4.7.', text: '4.7. Retroperitoneale Lymphknoten (also ohne Primärtumor)', short: 'Retroperitoneale Lymphknoten (also ohne Primärtumor)' },
          { value: '4.8.', text: '4.8. Retroperitoneum (z.B. Sarkome), o. n. A.', short: 'etroperitoneum (z.B. Sarkome)' },
          { value: '4.8.+', text: '4.8.+ Retroperitoneum (z.B. Sarkome) (mit Lymphknotenregion)', short: 'Retroperitoneum (z.B. Sarkome) (mit Lymphknotenregion)' },
          { value: '4.8.-', text: '4.8.- Retroperitoneum (z.B. Sarkome) (ohne Lymphknotenregion)', short: 'Retroperitoneum (z.B. Sarkome) (ohne Lymphknotenregion)' },
          { value: '4.9.', text: '4.9. Bauchwand (z.B. Sarkome), o. n. A.', short: 'Bauchwand (z.B. Sarkome)' },
          { value: '4.9.+', text: '4.9.+ Bauchwand (z.B. Sarkome) (mit Lymphknotenregion)', short: 'Bauchwand (z.B. Sarkome) (mit Lymphknotenregion)' },
          { value: '4.9.-', text: '4.9.- Bauchwand (z.B. Sarkome) (ohne Lymphknotenregion)', short: 'Bauchwand (z.B. Sarkome) (ohne Lymphknotenregion)' },
          { header: 'Becken mit/ ohne Lymphknotenregion' },
          { value: '5.', text: '5. Becken mit/ ohne Lymphknotenregion', short: 'Becken mit/ ohne Lymphknotenregion' },
          { value: '5.+', text: '5.+ Becken mit Lymphknotenregion', short: 'Becken mit Lymphknotenregion' },
          { value: '5.-', text: '5.- Becken ohne Lymphknotenregion', short: 'Becken ohne Lymphknotenregion' },
          { value: '5.1.', text: '5.1. Rektum, o. n. A.', short: 'Rektum' },
          { value: '5.1.+', text: '5.1.+ Rektum (mit Lymphknotenregion)', short: 'Rektum (mit Lymphknotenregion)' },
          { value: '5.1.-', text: '5.1.- Rektum (ohne Lymphknotenregion)', short: 'Rektum (ohne Lymphknotenregion)' },
          { value: '5.2.', text: '5.2. Analbereich, o. n. A.', short: 'Analbereich' },
          { value: '5.2.+', text: '5.2.+ Analbereich (mit Lymphknotenregion)', short: 'Analbereich (mit Lymphknotenregion)' },
          { value: '5.2.-', text: '5.2.- Analbereich (ohne Lymphknotenregion)', short: 'Analbereich (ohne Lymphknotenregion)' },
          { value: '5.3.', text: '5.3. Harnblase, o. n. A.', short: 'Harnblase' },
          { value: '5.3.+', text: '5.3.+ Harnblase (mit Lymphknotenregion)', short: 'Harnblase (mit Lymphknotenregion)' },
          { value: '5.3.-', text: '5.3.- Harnblase (ohne Lymphknotenregion)', short: 'Harnblase (ohne Lymphknotenregion)' },
          { value: '5.4.', text: '5.4. Prostata, o. n. A.', short: 'Prostata' },
          { value: '5.4.+', text: '5.4.+ Prostata (mit Lymphknotenregion)', short: 'Prostata (mit Lymphknotenregion)' },
          { value: '5.4.-', text: '5.4.- Prostata (ohne Lymphknotenregion)', short: 'Prostata (ohne Lymphknotenregion)' },
          { value: '5.5.', text: '5.5. Hoden, o. n. A.', short: 'Hoden' },
          { value: '5.5.+', text: '5.5.+ Hoden (mit Lymphknotenregion)', short: 'Hoden (mit Lymphknotenregion)' },
          { value: '5.5.-', text: '5.5.- Hoden (ohne Lymphknotenregion)', short: 'Hoden (ohne Lymphknotenregion)' },
          { value: '5.6.', text: '5.6. Penis, o. n. A.', short: 'Penis' },
          { value: '5.6.+', text: '5.6.+ Penis (mit Lymphknotenregion)', short: 'Penis (mit Lymphknotenregion)' },
          { value: '5.6.-', text: '5.6.- Penis (ohne Lymphknotenregion)', short: 'Penis (ohne Lymphknotenregion)' },
          { value: '5.7.', text: '5.7. Uterus/Zervix, o. n. A.', short: 'Uterus/Zervix' },
          { value: '5.7.+', text: '5.7.+ Uterus/Zervix (mit Lymphknotenregion)', short: 'Uterus/Zervix (mit Lymphknotenregion)' },
          { value: '5.7.-', text: '5.7.- Uterus/Zervix (ohne Lymphknotenregion)', short: 'Uterus/Zervix (ohne Lymphknotenregion)' },
          { value: '5.7.1.', text: '5.7.1. Uterus', short: 'Uterus' },
          { value: '5.7.1.+', text: '5.7.1.+ Uterus (mit Lymphknotenregion)', short: 'Uterus (mit Lymphknotenregion)' },
          { value: '5.7.1.-', text: '5.7.1.- Uterus (ohne Lymphknotenregion)', short: 'Uterus (ohne Lymphknotenregion)' },
          { value: '5.7.2.', text: '5.7.2. Zervix', short: 'Zervix' },
          { value: '5.7.2.+', text: '5.7.2.+ Zervix (mit Lymphknotenregion)', short: 'Zervix (mit Lymphknotenregion)' },
          { value: '5.7.2.-', text: '5.7.2.- Zervix (ohne Lymphknotenregion)', short: 'Zervix (ohne Lymphknotenregion)' },
          { value: '5.8.', text: '5.8. Ovar, o. n. A.', short: 'Ovar' },
          { value: '5.8.+', text: '5.8.+ Ovar (mit Lymphknotenregion)', short: 'Ovar (mit Lymphknotenregion)' },
          { value: '5.8.-', text: '5.8.- Ovar (ohne Lymphknotenregion)', short: 'Ovar (ohne Lymphknotenregion)' },
          { value: '5.9.', text: '5.9. Vulva, o. n. A.', short: 'Vulva' },
          { value: '5.9.+', text: '5.9.+ Vulva (mit Lymphknotenregion)', short: 'Vulva (mit Lymphknotenregion)' },
          { value: '5.9.-', text: '5.9.- Vulva (ohne Lymphknotenregion)', short: 'Vulva (ohne Lymphknotenregion)' },
          { value: '5.10.', text: '5.10. Vagina, o. n. A.', short: 'Vagina' },
          { value: '5.10.+', text: '5.10.+ Vagina (mit Lymphknotenregion)', short: 'Vagina (mit Lymphknotenregion)' },
          { value: '5.10.-', text: '5.10.- Vagina (ohne Lymphknotenregion)', short: 'Vagina (ohne Lymphknotenregion)' },
          { value: '5.11.', text: '5.11. Beckenwand, o. n. A.', short: 'Beckenwand' },
          { value: '5.11.+', text: '5.11.+ Beckenwand (mit Lymphknotenregion)', short: 'Beckenwand (mit Lymphknotenregion)' },
          { value: '5.11.-', text: '5.11.- Beckenwand (ohne Lymphknotenregion)', short: 'Beckenwand (ohne Lymphknotenregion)' },
          { value: '5.12.', text: '5.12. Beckenlymphknoten (ohne Primärtumor)', short: 'Beckenlymphknoten (ohne Primärtumor)' },
          { header: 'Stütz-/Bewegungsapparat' },
          { value: '6.', text: '6. Stütz-/Bewegungsapparat', short: 'Stütz-/Bewegungsapparat' },
          { value: '6.1.', text: '6.1. Schädelknochen', short: 'Schädelknochen' },
          { value: '6.2.', text: '6.2. Rippen', short: 'Rippen' },
          { value: '6.3.', text: '6.3. Sternum', short: 'Sternum' },
          { value: '6.4.', text: '6.4. HWS', short: 'HWS' },
          { value: '6.5.', text: '6.5. BWS', short: 'BWS' },
          { value: '6.6.', text: '6.6. LWS', short: 'LWS' },
          { value: '6.7.', text: '6.7. knöchernes Becken', short: 'knöchernes Becken' },
          { value: '6.8.', text: '6.8. Hüfte', short: 'Hüfte' },
          { value: '6.9.', text: '6.9. Achsel', short: 'Achsel' },
          { value: '6.10.', text: '6.10. Oberarm', short: 'Oberarm' },
          { value: '6.11.', text: '6.11. Unterarm', short: 'Unterarm' },
          { value: '6.12.', text: '6.12. Hand', short: 'Hand' },
          { value: '6.13.', text: '6.13. Leiste', short: 'Leiste' },
          { value: '6.14.', text: '6.14. Oberschenkel', short: 'Oberschenkel' },
          { value: '6.15.', text: '6.15. Unterschenkel', short: 'Unterschenkel' },
          { value: '6.16.', text: '6.16. Fuß', short: 'Fuß' },
          { header: 'Haut' },
          { value: '7.', text: '7. Haut', short: 'Haut' },
          { value: '7.+', text: '7.+ Haut (mit Lymphknotenregion)', short: 'Haut (mit Lymphknotenregion)' },
          { value: '7.-', text: '7.- Haut (ohne Lymphknotenregion)', short: 'Haut (ohne Lymphknotenregion)' },
          { value: '7.1.', text: '7.1. Primärer Hauttumor (auch kutane Lymphome)', short: 'Primärer Hauttumor (auch kutane Lymphome)' },
          { value: '7.2.', text: '7.2. Hautmetastasen', short: 'Hautmetastasen' },
          { header: 'Sonstiges' },
          { value: '8.', text: '8. Sonstiges', short: 'Sonstiges' },
          { value: '8.1.', text: '8.1. Ganzkörperbestrahlung', short: 'Ganzkörperbestrahlung' },
          { value: '8.2.', text: '8.2. Mantelfeldbestrahlung', short: 'Mantelfeldbestrahlung' }
        ],
        // oBDS_Zielgebiet2021_Typ
        ST_ZielgebietTypes2021: [
          { header: 'ZNS' },
          { value: '1.1', text: '1.1 Ganzhirn (Neurokranium, inklusive Meningen)', short: 'Ganzhirn (Neurokranium, inklusive Meningen)' },
          { value: '1.2', text: '1.2 Teilhirn (frontal/parietal/occipital/temporal/Kleinhirn)', short: 'Teilhirn (frontal/parietal/occipital/temporal/Kleinhirn)' },
          { value: '1.3', text: '1.3 Neuroachse/Rückenmark', short: 'Neuroachse/Rückenmark' },
          { value: '1.4', text: '1.4 Hypophyse', short: 'Hypophyse' },
          { value: '1.5', text: '1.5 Hirn sonstiges', short: 'Hirn sonstiges' },
          { header: 'Kopf-Hals' },
          { value: '2.1', text: '2.1 Auge', short: 'Auge', onlyLR: true },
          { value: '2.2', text: '2.2 Nase/Nasennebenhöhle', short: 'Nase/Nasennebenhöhle' },
          { value: '2.3', text: '2.3 Mundhöhle inklusive Mundhöhlenvorhof', short: 'Mundhöhle inklusive Mundhöhlenvorhof' },
          { value: '2.4', text: '2.4 Ohr', short: 'Ohr', onlyLR: true },
          { value: '2.5', text: '2.5 Speicheldrüse', short: 'Speicheldrüse', onlyLR: true },
          { value: '2.6', text: '2.6 Pharynx', short: 'Pharynx' },
          { value: '2.7', text: '2.7 Nasopharynx', short: 'Nasopharynx' },
          { value: '2.8', text: '2.8 Oropharynx', short: 'Oropharynx' },
          { value: '2.9', text: '2.9 Hypopharynx', short: 'Hypopharynx' },
          { value: '2.10', text: '2.10 Larynx', short: 'Larynx' },
          { value: '2.11', text: '2.11 Schilddrüse', short: 'Schilddrüse' },
          { value: '2.12', text: '2.12 Kopf-Hals sonstige', short: 'Kopf-Hals sonstige' },
          { header: 'Thorax' },
          { value: '3.1', text: '3.1 Mamma als Ganzbrust', short: 'Mamma als Ganzbrust', onlyLR: true },
          { value: '3.2', text: '3.2 Mamma als Teilbrust', short: 'Mamma als Teilbrust', onlyLR: true },
          { value: '3.3', text: '3.3 Thoraxwand, gegebenenfalls', short: 'Thoraxwand, gegebenenfalls', onlyLR: true },
          { value: '3.4', text: '3.4 Lunge', short: 'Lunge', onlyLR: true },
          { value: '3.5', text: '3.5 Ösophagus', short: 'Ösophagus' },
          { value: '3.6', text: '3.6 Mediastinum (mediastinaler Lymphabfluss ist in Nummer 9 zu kodieren)', short: 'Mediastinum (mediastinaler Lymphabfluss ist in Nummer 9 zu kodieren)' },
          { value: '3.7', text: '3.7 Thymus', short: 'Thymus' },
          { value: '3.8', text: '3.8 Thorax sonstige', short: 'Thorax sonstige' },
          { header: 'Abdomen' },
          { value: '4.1', text: '4.1 Magen', short: 'Magen' },
          { value: '4.2', text: '4.2 Pankreas', short: 'Pankreas' },
          { value: '4.3', text: '4.3 Leber, auch bei Teilbestrahlung', short: 'Leber, auch bei Teilbestrahlung' },
          { value: '4.4', text: '4.4 Milz', short: 'Milz' },
          { value: '4.5', text: '4.5 Niere', short: 'Niere', onlyLR: true },
          { value: '4.6', text: '4.6 Nebenniere', short: 'Nebenniere', onlyLR: true },
          { value: '4.7', text: '4.7 Retroperitoneum (z.B. Sarkome)', short: 'Retroperitoneum (z.B. Sarkome)' },
          { value: '4.8', text: '4.8 Ureter', short: 'Ureter', onlyLR: true },
          { value: '4.9', text: '4.9 Bauchwand (z.B. Sarkome)', short: 'Bauchwand (z.B. Sarkome)' },
          { value: '4.10', text: '4.10 Oberbauch', short: 'Oberbauch' },
          { value: '4.11', text: '4.11 Gallengänge', short: 'Gallengänge' },
          { value: '4.12', text: '4.12 Gallenblase', short: 'Gallenblase' },
          { value: '4.13', text: '4.13 Abdomen sonstige', short: 'Abdomen sonstige' },
          { header: 'Becken (Organe)' },
          { value: '5.1', text: '5.1 Rektum', short: 'Rektum' },
          { value: '5.2', text: '5.2 Analbereich', short: 'Analbereich' },
          { value: '5.3', text: '5.3 Harnblase', short: 'Harnblase' },
          { value: '5.4', text: '5.4 Prostata', short: 'Prostata' },
          { value: '5.5', text: '5.5 Hoden', short: 'Hoden', onlyLR: true },
          { value: '5.6', text: '5.6 Penis', short: 'Penis' },
          { value: '5.7', text: '5.7 Uterus', short: 'Uterus' },
          { value: '5.8', text: '5.8 Zervix', short: 'Zervix' },
          { value: '5.9', text: '5.9 Vulva', short: 'Vulva' },
          { value: '5.10', text: '5.10 Vagina', short: 'Vagina' },
          { value: '5.11', text: '5.11 Beckenwand', short: 'Beckenwand' },
          { value: '5.12', text: '5.12 Becken sonstige', short: 'Becken sonstige' },
          { header: 'Knochen/Skelettsystem' },
          { value: '6.1', text: '6.1 Schädel', short: 'Schädel' },
          { value: '6.2', text: '6.2 Schädelbasis', short: 'Schädelbasis' },
          { value: '6.3', text: '6.3 Orbita', short: 'Orbita', onlyLR: true },
          { value: '6.4', text: '6.4 Halswirbelsäule', short: 'Halswirbelsäule' },
          { value: '6.5', text: '6.5 Brustwirbelsäule', short: 'Brustwirbelsäule' },
          { value: '6.6', text: '6.6 Lendenwirbelsäule', short: 'Lendenwirbelsäule' },
          { value: '6.7', text: '6.7 Sacrum/Coccygeum', short: 'Sacrum/Coccygeum' },
          { value: '6.8', text: '6.8 Rippen', short: 'Rippen', onlyLR: true },
          { value: '6.9', text: '6.9 Sternum', short: 'Sternum' },
          { value: '6.10', text: '6.10 Schulter', short: 'Schulter', onlyLR: true },
          { value: '6.11', text: '6.11 Oberarm', short: 'Oberarm', onlyLR: true },
          { value: '6.12', text: '6.12 Unterarm', short: 'Unterarm', onlyLR: true },
          { value: '6.13', text: '6.13 Hand', short: 'Hand', onlyLR: true },
          { value: '6.14', text: '6.14 Becken', short: 'Becken', onlyLR: true },
          { value: '6.15', text: '6.15 Hüfte', short: 'Hüfte', onlyLR: true },
          { value: '6.16', text: '6.16 Oberschenkel', short: 'Oberschenkel', onlyLR: true },
          { value: '6.17', text: '6.17 Unterschenkel', short: 'Unterschenkel', onlyLR: true },
          { value: '6.18', text: '6.18 Fuß', short: 'Fuß', onlyLR: true },
          { value: '6.18', text: '6.19 Knochen sonstige', short: 'Knochen sonstige' },
          { header: 'Bindegewebe (Subkutangewebe, Fettgewebe, Muskeln, anderes Bindegewebe)' },
          { value: '7.1', text: '7.1 Kopf, Gesicht, Hals', short: 'Kopf, Gesicht, Hals' },
          { value: '7.2', text: '7.2 obere Extremität inklusive Schulter', short: 'obere Extremität inklusive Schulter', onlyLR: true },
          { value: '7.3', text: '7.3 untere Extremität und Hüfte', short: 'untere Extremität und Hüfte', onlyLR: true },
          { value: '7.4', text: '7.4 Thorax', short: 'Thorax' },
          { value: '7.5', text: '7.5 Abdomen', short: 'Abdomen' },
          { value: '7.6', text: '7.6 Becken', short: 'Becken' },
          { value: '7.7', text: '7.7 Stammes o. n. A.', short: 'Stammes o. n. A.' },
          { value: '7.8', text: '7.8 mehrere Bereiche überlappend', short: 'mehrere Bereiche überlappend' },
          { value: '7.9', text: '7.9 sonstige Weichteile o. n. A.', short: 'sonstige Weichteile o. n. A.' },
          { header: 'Haut' },
          { value: '8.1', text: '8.1 Ganzhaut', short: 'Ganzhaut' },
          { value: '8.2', text: '8.2 Teilbereiche', short: 'Teilbereiche' },
          { header: 'Lymphabflussregionen und Lymphknoten' },
          { value: '9.1', text: '9.1 Cervikale Lymphknoten', short: 'Cervikale Lymphknoten', onlyLR: true },
          { value: '9.2', text: '9.2 Supra-/infraclavikuläre Lymphknoten', short: 'Supra-/infraclavikuläre Lymphknoten', onlyLR: true },
          { value: '9.3', text: '9.3 Axilläre Lymphknoten', short: 'Axilläre Lymphknoten', onlyLR: true },
          { value: '9.4', text: '9.4 Retrosternale/sternale/Mammaria interna Lymphknoten', short: 'Retrosternale/sternale/Mammaria interna Lymphknoten' },
          { value: '9.5', text: '9.5 Mediastinale Lymphknoten', short: 'Mediastinale Lymphknoten' },
          { value: '9.6', text: '9.6 Hiläre Lymphknoten', short: 'Hiläre Lymphknoten' },
          { value: '9.7', text: '9.7 Intraabdominale Lymphknoten (z.B. subphrenisch, perigastrisch, peripankreatisch, Leber-, Milzhilus)', short: 'Intraabdominale Lymphknoten (z. B. subphrenisch, perigastrisch, peripankreatisch, Leber-, Milzhilus)' },
          { value: '9.8', text: '9.8 Paraaortale/paracavale Lymphknoten', short: 'Paraaortale/paracavale Lymphknoten' },
          { value: '9.9', text: '9.9 Retroperitoneale Lymphknoten', short: 'Retroperitoneale Lymphknoten' },
          { value: '9.10', text: '9.10 Beckenlymphabfluss (Iliakal commun, extern, intern, obturatorisch, präsakral)', short: 'Beckenlymphabfluss (Iliakal commun, extern, intern, obturatorisch, präsakral)', onlyLR: true },
          { value: '9.11', text: '9.11 Inguinale Lymphknoten', short: 'Inguinale Lymphknoten', onlyLR: true },
          { value: '9.12', text: '9.12 Involved Node', short: 'Involved Node' },
          { value: '9.13', text: '9.13 Involved Site', short: 'Involved Site' },
          { value: '9.14', text: '9.14 Involved Field', short: 'Involved Field' },
          { value: '9.15', text: '9.15 Sonstige Lymphknoten', short: 'Sonstige Lymphknoten' },
          { header: 'Spezielle Zielgebiete' },
          { value: '10.1', text: '10.1 Ganzkörperbestrahlung bei allogener Stammzelltransplantation', short: 'Ganzkörperbestrahlung bei allogener Stammzelltransplantation' },
          { value: '10.2', text: '10.2 operative Zugangswege', short: 'operative Zugangswege' },
          { value: '10.3', text: '10.3 Sonstige, nicht genannte Zielgebiete', short: 'Sonstige, nicht genannte Zielgebiete' }
        ],
        ST_Seite_ZielgebietTypes: [
          { value: 'L', text: 'Links' },
          { value: 'R', text: 'Rechts' },
          { value: 'B', text: 'Beidseits' },
          { value: 'M', text: 'Mittig' },
          { value: 'U', text: 'Unbekannt' },
          { value: 'T', text: 'Trifft nicht zu' }
        ],
        ST_Seite_ZielgebietTypes_onlyLR: [
          { value: 'L', text: 'Links' },
          { value: 'R', text: 'Rechts' },
          { value: 'B', text: 'Beidseits' }
        ],
        ST_ApplikationsartTypes: {
          perkutan: {
            label: 'Perkutan',
            value: 'perkutan',
            types: [
              {
                value: 'radiochemo',
                text: 'Radiochemo',
                required: true,
                list: [
                  { value: 'RCJ', text: 'RCJ - Mit Chemotherapie/Sensitizer' },
                  { value: 'RCN', text: 'RCN - Ohne Chemotherapie/Sensitizer' }
                ],
                elementsToDelete: ['stereotaktisch', 'atemgetriggert']
              },
              {
                value: 'stereotaktisch',
                text: 'Stereotaktisch',
                required: false,
                list: [
                  { value: 'ST', text: 'ST - Stereotaktisch' }
                ],
                elementsToDelete: ['radiochemo', 'atemgetriggert']
              },
              {
                value: 'atemgetriggert',
                text: 'Atemgetriggert',
                required: false,
                list: [
                  { value: '4D', text: '4D - Atemgetriggert' }
                ],
                elementsToDelete: ['radiochemo', 'stereotaktisch']
              }
            ],
            strahlenart: [
              { value: 'UH', text: 'UH - Photonen (ultraharte Röntgenstrahlen, inkl. Gamma-Strahler)' },
              { value: 'EL', text: 'EL - Elektronen' },
              { value: 'NE', text: 'NE - Neutronen' },
              { value: 'PN', text: 'PN - Protonen (leichte Wasserstoffionen/H1/Leichtionen)' },
              { value: 'SI', text: 'SI - Schwerionen (schwere Kohlenstoff-Ionen/C12/Sauerstoffionen/Heliumionen)' },
              { value: 'RO', text: 'RO - Weichstrahl (kV)' },
              { value: 'Co-60', text: 'Co-60' },
              { value: 'SO', text: 'SO - Sonstige' }
            ],
            units: [
              { value: 'Gy', text: 'Gy' }
            ],
            boost: true
          },
          kontakt: {
            label: 'Kontakt',
            value: 'kontakt',
            required: true,
            types: [
              {
                value: 'interstitiell_endokavitaer',
                text: 'Interstitiell endokavitaer',
                required: true,
                list: [
                  { value: 'I', text: 'I - Interstitiell' },
                  { value: 'K', text: 'K - Endokavitär' }
                ],
                elementsToDelete: ['rate_type']
              },
              {
                value: 'rate_type',
                text: 'Rate Type',
                required: true,
                list: [
                  { value: 'HDR', text: 'HDR - High dose rate therapy' },
                  { value: 'LDR', text: 'LDR - Low dose rate therapy' },
                  { value: 'PDR', text: 'PDR - Pulsed dose rate therapy' }
                ],
                elementsToDelete: ['interstitiell_endokavitaer']
              }
            ],
            strahlenart: [
              { value: 'UH', text: 'UH' },
              { value: 'EL', text: 'EL' },
              { value: 'SO', text: 'SO - Sonstige' }
            ],
            units: [
              { value: 'Gy', text: 'Gy' }
            ],
            boost: true
          },
          metabolisch: {
            label: 'Metabolisch',
            value: 'metabolisch',
            required: true,
            types: [
              {
                value: 'metabolisch_typ',
                required: true,
                list: [
                  { value: 'SIRT', text: 'SIRT - Selektive interne Radio-Therapie' },
                  { value: 'PRRT', text: 'PRRT - Peptid-Radio-Rezeptor-Therapie' },
                  { value: 'PSMA', text: 'PSMA - PSMA-Therapie' },
                  { value: 'RJT', text: 'RJT - Radiojod-Therapie' },
                  { value: 'RIT', text: 'RIT - Radioimmun-Therapie' },
                  { value: 'M', text: 'M - Sonstige metabolische Radionuklidtherapie' }
                ],
                elementsToDelete: []
              }
            ],
            strahlenart: [
              { value: 'Lu-177', text: 'Lu-177' },
              { value: 'J-131', text: 'J-131' },
              { value: 'Y-90', text: 'Y-90' },
              { value: 'Ra-223', text: 'Ra-223' },
              { value: 'Ac-225', text: 'Ac-225' },
              { value: 'Sm-153', text: 'Sm-153' },
              { value: 'Tb-161', text: 'Tb-161' },
              { value: 'Sr-89', text: 'Sr-89' },
              { value: 'Ir-192', text: 'Ir-192' },
              { value: 'SONU', text: 'SO - Sonstige Nuklide' }
            ],
            units: [
              { value: 'GBq', text: 'GBq' },
              { value: 'MBq', text: 'MBq' },
              { value: 'kBq', text: 'kBq' }
            ]
          },
          sonstige: {
            label: 'Sonstige',
            value: 'sonstige',
            required: false,
            types: [], // there is no type defined
            strahlenart: [], // there is no kind of radiation defined
            units: [
              { value: 'Gy', text: 'Gy' }
            ]
          }
        },
        EinheitTypes: [
          { value: 'Gy', text: 'Gy' }
        ],
        AktivitaetsTypes: [
          { value: 'GBq', text: 'GBq' },
          { value: 'MBq', text: 'MBq' },
          { value: 'kBq', text: 'kBq' }
        ],
        BoostTypes: [
          { value: 'J', text: 'J - Ja, mit Boost o. n. A.' },
          { value: 'SIB', text: 'SIB - Simultan integrierter Boost' },
          { value: 'SEQ', text: 'SEQ - Sequentieller Boost' },
          { value: 'KON', text: 'KON - Konkomitanter Boost' },
          { value: 'N', text: 'N - Nein, ohne Boost' }
        ],
        SYST_Ende_GrundTypes: [
          { value: 'E', text: 'E - Reguläres Ende' },
          { value: 'R', text: 'R - Reguläres Ende mit Dosisreduktion' },
          { value: 'W', text: 'W - Reguläres Ende mit Substanzwechsel' },
          { value: 'A', text: 'A - Abbruch wegen Nebenwirkungen' },
          { value: 'P', text: 'P - Abbruch wegen Progress' },
          { value: 'S', text: 'S - Abbruch aus sonstigen Gründen' },
          { value: 'V', text: 'V - Patient verweigert weitere Therapie' },
          { value: 'T', text: 'T - Patient verstorben' },
          { value: 'U', text: 'U - Unbekannt' }
        ],
        SYST_IntentionTypes: [
          { value: 'K', text: 'Kurativ' },
          { value: 'P', text: 'Palliativ' },
          { value: 'S', text: 'Sonstiges' },
          { value: 'X', text: 'Keine Angabe' }
        ],
        SYST_Stellung_OPTypes: [
          { value: 'O', text: 'Ohne Bezug' },
          { value: 'A', text: 'Adjuvant' },
          { value: 'N', text: 'Neoadjuvant' },
          { value: 'I', text: 'Intraoperativ' },
          { value: 'S', text: 'Sonstiges' }
        ],
        SYST_TherapyArtTypes: [
          { header: 'Arzneimittel' },
          { value: 'HO', text: 'HO - Hormontherapie', short: 'Hormontherapie' },
          { value: 'CH', text: 'CH - Chemotherapie', short: 'Chemotherapie' },
          { value: 'CI', text: 'CI - Chemotherapie + Immun-/Antikörpertherapie', short: 'Chemo- + Immun-/Antikörpertherapie' },
          { value: 'IM', text: 'IM - Immun- und Antikörpertherapie', short: 'Immun- und Antikörpertherapie' },
          { value: 'ZS', text: 'ZS - Zielgerichtete Substanzen', short: 'Zielgerichtete Substanzen' },
          { value: 'IZ', text: 'IZ - Immun-/Antikörpertherapie + zielgerichtete Substanzen', short: 'Immun + zielgerichtete Substanzen' },
          { value: 'CZ', text: 'CZ - Chemotherapie + zielgerichtete Substanzen', short: 'Chemotherapie + zielgerichtete Substanzen' },
          { value: 'CIZ', text: 'CIZ - Chemotherapie + Immun-/Antikörpertherapie + zielgerichtete Substanzen', short: 'Chemo- + Immun-/Antikörpertherapie + zielgerichtete Substanzen' },
          { header: 'Weitere Therapien' },
          { value: 'SZ', text: 'SZ - Stammzelltransplantation (inkl. Knochenmarktransplantation)', short: 'Stammzelltransplantation' },
          { value: 'SO', text: 'SO - Sonstiges', short: 'Sonstiges' },
          { header: 'Passive Therapien' },
          { value: 'WS', text: 'WS - Wait and see', short: 'Wait and see' },
          { value: 'AS', text: 'AS - Active Surveillance', short: 'Aktive Überwachung' },
          { value: 'WW', text: 'WW - Watchful Waiting', short: 'Watchful Waiting' }
        ],
        SYST_Passive_TherapyArtTypes: [
          { header: 'Weitere Therapien' },
          { value: 'SZ', text: 'SZ - Stammzelltransplantation (inkl. Knochenmarktransplantation)', short: 'Stammzelltransplantation' },
          { value: 'SO', text: 'SO - Sonstiges', short: 'Sonstiges' },
          { header: 'Passive Therapien' },
          { value: 'WS', text: 'WS - Wait and see', short: 'Wait and see' },
          { value: 'AS', text: 'AS - Aktive Überwachung', short: 'Aktive Überwachung' },
          { value: 'WW', text: 'WW - Watchful Waiting', short: 'Watchful Waiting' }
        ],
        Tumorkonferenz_TypTypes: [
          { value: 'praeth', text: 'praeth - prätherapeutisch (Festlegung der Gesamttherapiestrategie, z.B. neoadjuvant oder direkte Operation)' },
          { value: 'postop', text: 'postop - postoperativ (Planung der postoperativen Therapie, z.B. zur Frage adjuvante Therapie)' },
          { value: 'postth', text: 'postth - posttherapeutisch (manche Tumoren werden nicht operiert)' },
          { value: 'ther', text: 'ther - Therapieplanung ohne Tumorkonferenz' }
        ],
        Tumorkonferenz_TypTypes_Long: [
          { value: 'praethDiagnosis', text: 'praeth (Diagnose) - prätherapeutisch (Festlegung der Gesamttherapiestrategie, z.B. neoadjuvant oder direkte Operation)' },
          { value: 'praethTreatment', text: 'praeth (Behandlungsbeginn) - prätherapeutisch (Festlegung der Gesamttherapiestrategie, z.B. neoadjuvant oder direkte Operation)' },
          { value: 'praethState', text: 'praeth (Statusänderung) - prätherapeutisch (Festlegung der Gesamttherapiestrategie, z.B. neoadjuvant oder direkte Operation)' },
          { value: 'postop', text: 'postop - postoperativ (Planung der postoperativen Therapie, z.B. zur Frage adjuvante Therapie)' },
          { value: 'postth', text: 'postth - posttherapeutisch (manche Tumoren werden nicht operiert)' },
          { value: 'therDiagnosis', text: 'ther (Diagnose) - Therapieplanung ohne Tumorkonferenz' },
          { value: 'therTreatment', text: 'ther (Behandlungsbeginn) - Therapieplanung ohne Tumorkonferenz' },
          { value: 'therState', text: 'ther (Statusänderung) - Therapieplanung ohne Tumorkonferenz' }
        ],
        Tumorkonferenz_EmpfehlungTypes: [
          { value: 'CH', text: 'Chemotherapie' },
          { value: 'HO', text: 'Hormontherapie' },
          { value: 'IM', text: 'Immun-/Antikörpertherapie' },
          { value: 'ZS', text: 'Zielgerichtete Substanzen' },
          { value: 'SZ', text: 'Stammzelltransplantation (inkl. Knochenmarktransplantation)' },
          { value: 'CI', text: 'Chemo- + Immun-/Antikörpertherapie' },
          { value: 'CZ', text: 'Chemotherapie + zielgerichtete Substanzen' },
          { value: 'CIZ', text: 'Chemo- + Immun-/Antikörpertherapie + zielgerichtete Substanzen' },
          { value: 'IZ', text: 'Immun-/Antikörpertherapie + zielgerichtete Substanzen' },
          { value: 'WW', text: 'Watchful Waiting' },
          { value: 'AS', text: 'Active Surveillance' },
          { value: 'WS', text: 'Wait and see' },
          { value: 'OP', text: 'Operation' },
          { value: 'ST', text: 'Strahlentherapie' },
          { value: 'SO', text: 'Sonstiges' },
          { value: 'KW', text: 'Keine weitere tumorspezifische Therapie empfohlen' }
        ],
        GeneticExpressions: [
          { value: 'M', text: 'M - Mutation/positiv' },
          { value: 'W', text: 'W - Wildtyp/nicht mutiert/negativ' },
          { value: 'P', text: 'P - Polymorphismus' },
          { value: 'N', text: 'N - Nicht bestimmbar' },
          { value: 'U', text: 'U - Unbekannt' }
        ],
        DateAccuracyLong: [
          { value: 'E', text: 'E - Exakt (entspricht taggenau)' },
          { value: 'T', text: 'T - Tag geschätzt (entspricht monatsgenau)' },
          { value: 'M', text: 'M - Monat geschätzt (entspricht jahrgenau)' },
          { value: 'V', text: 'V - Vollständig geschätzt (genaue Angabe zum Jahr nicht möglich)' }
        ],
        DateAccuracyShort: [
          { value: 'E', text: 'E - Exakt (entspricht taggenau)' },
          { value: 'T', text: 'T - Tag geschätzt (entspricht monatsgenau)' }
        ],
        ReplacementCodeTypes: [
          { value: '970000011', text: '970000011 - Selbstzahler' },
          { value: '970001001', text: '970001001 - Kostenträger ohne IK-Nummer (z.B. Gefängnisinsassen)' },
          { value: '970100001', text: '970100001 - Asylbewerber' },
          { value: '970000022', text: '970000022 - Privatversichert, Kasse unbekannt' },
          { value: '970000099', text: '970000099 - Keine Angabe zum Kostenträger' }
        ],
        countryTypes: [
          { value: 'DE', text: 'Deutschland' },
          { header: 'A' },
          { value: 'AF', text: 'Afghanistan' },
          { value: 'EG', text: 'Ägypten' },
          { value: 'AL', text: 'Albanien' },
          { value: 'DZ', text: 'Algerien' },
          { value: 'AD', text: 'Andorra' },
          { value: 'AO', text: 'Angola' },
          { value: 'AI', text: 'Anguilla' },
          { value: 'AQ', text: 'Antarktis' },
          { value: 'AG', text: 'Antigua und Barbuda' },
          { value: 'AE', text: 'Arabische Emirate, Vereinigte' },
          { value: 'AR', text: 'Argentinien' },
          { value: 'AM', text: 'Armenien' },
          { value: 'AW', text: 'Aruba' },
          { value: 'AZ', text: 'Aserbaidschan' },
          { value: 'ET', text: 'Äthiopien' },
          { value: 'AU', text: 'Australien' },
          { header: 'B' },
          { value: 'BS', text: 'Bahamas' },
          { value: 'BH', text: 'Bahrain' },
          { value: 'BD', text: 'Bangladesch' },
          { value: 'BB', text: 'Barbados' },
          { value: 'BY', text: 'Belarus' },
          { value: 'BE', text: 'Belgien' },
          { value: 'BZ', text: 'Belize' },
          { value: 'BJ', text: 'Benin' },
          { value: 'BM', text: 'Bermuda' },
          { value: 'BT', text: 'Bhutan' },
          { value: 'BO', text: 'Bolivien' },
          { value: 'BA', text: 'Bosnien und Herzegowina' },
          { value: 'BR', text: 'Brasilien' },
          { value: 'BG', text: 'Bulgarien' },
          { value: 'BF', text: 'Burkina Faso' },
          { value: 'BI', text: 'Burundi' },
          { header: 'C' },
          { value: 'CL', text: 'Chile' },
          { value: 'CN', text: 'China' },
          { value: 'CR', text: 'Costa Rica' },
          { value: 'CW', text: 'Curacao' },
          { header: 'D' },
          { value: 'DK', text: 'Dänemark' },
          { value: 'DM', text: 'Dominica' },
          { value: 'DO', text: 'Dominikanische Republik' },
          { value: 'DJ', text: 'Dschibuti' },
          { header: 'E' },
          { value: 'EC', text: 'Ecuador' },
          { value: 'SV', text: 'El Salvador' },
          { value: 'ER', text: 'Eritrea' },
          { value: 'EE', text: 'Estland' },
          { header: 'F' },
          { value: 'FK', text: 'Falklandinseln' },
          { value: 'FO', text: 'Färöer' },
          { value: 'FJ', text: 'Fidschi' },
          { value: 'FI', text: 'Finnland' },
          { value: 'FR', text: 'Frankreich' },
          { value: 'PF', text: 'Französisch-Polynesien' },
          { header: 'G' },
          { value: 'GA', text: 'Gabun' },
          { value: 'GM', text: 'Gambia' },
          { value: 'GE', text: 'Georgien' },
          { value: 'GH', text: 'Ghana' },
          { value: 'GI', text: 'Gibraltar' },
          { value: 'GD', text: 'Grenada' },
          { value: 'GR', text: 'Griechenland' },
          { value: 'GL', text: 'Grönland' },
          { value: 'GU', text: 'Guam' },
          { value: 'GB', text: 'Großbritannien' },
          { value: 'GT', text: 'Guatemala' },
          { value: 'GN', text: 'Guinea' },
          { value: 'GY', text: 'Guyana' },
          { header: 'H' },
          { value: 'HT', text: 'Haiti' },
          { value: 'HN', text: 'Honduras' },
          { value: 'HK', text: 'Hongkong' },
          { header: 'I' },
          { value: 'IN', text: 'Indien' },
          { value: 'ID', text: 'Indonesien' },
          { value: 'IQ', text: 'Irak' },
          { value: 'IR', text: 'Iran' },
          { value: 'IE', text: 'Irland' },
          { value: 'IS', text: 'Island' },
          { value: 'IL', text: 'Israel' },
          { value: 'IT', text: 'Italien' },
          { header: 'J' },
          { value: 'JM', text: 'Jamaika' },
          { value: 'JP', text: 'Japan' },
          { value: 'YE', text: 'Jemen' },
          { value: 'JO', text: 'Jordanien' },
          { header: 'K' },
          { value: 'KY', text: 'Kaimaninseln' },
          { value: 'KH', text: 'Kambodscha' },
          { value: 'CM', text: 'Kamerun' },
          { value: 'CA', text: 'Kanada' },
          { value: 'KZ', text: 'Kasachstan' },
          { value: 'QA', text: 'Katar' },
          { value: 'KE', text: 'Kenia' },
          { value: 'KG', text: 'Kirgisistan' },
          { value: 'CO', text: 'Kolumbien' },
          { value: 'KM', text: 'Komoren' },
          { value: 'CG', text: 'Kongo' },
          { value: 'KP', text: 'Nordkorea' },
          { value: 'KR', text: 'Südkorea' },
          { value: 'XK', text: 'Kosovo' },
          { value: 'HR', text: 'Kroatien' },
          { value: 'CU', text: 'Kuba' },
          { value: 'KW', text: 'Kuwait' },
          { header: 'L' },
          { value: 'LA', text: 'Laos' },
          { value: 'LS', text: 'Lesotho' },
          { value: 'LV', text: 'Lettland' },
          { value: 'LB', text: 'Libanon' },
          { value: 'LR', text: 'Liberia' },
          { value: 'LY', text: 'Libyen' },
          { value: 'LI', text: 'Liechtenstein' },
          { value: 'LT', text: 'Litauen' },
          { value: 'LU', text: 'Luxemburg' },
          { header: 'M' },
          { value: 'MO', text: 'Macau' },
          { value: 'MG', text: 'Madagaskar' },
          { value: 'MW', text: 'Malawi' },
          { value: 'MY', text: 'Malaysia' },
          { value: 'MV', text: 'Malediven' },
          { value: 'ML', text: 'Mali' },
          { value: 'MT', text: 'Malta' },
          { value: 'MA', text: 'Marokko' },
          { value: 'MH', text: 'Marshallinseln' },
          { value: 'MR', text: 'Mauretanien' },
          { value: 'MU', text: 'Mauritius' },
          { value: 'MX', text: 'Mexiko' },
          { value: 'FM', text: 'Mikronesien' },
          { value: 'MD', text: 'Moldau' },
          { value: 'MN', text: 'Mongolei' },
          { value: 'ME', text: 'Montenegro' },
          { value: 'MS', text: 'Montserrat' },
          { value: 'MZ', text: 'Mosambik' },
          { value: 'MM', text: 'Myanmar' },
          { header: 'N' },
          { value: 'NA', text: 'Namibia' },
          { value: 'NP', text: 'Nepal' },
          { value: 'NC', text: 'Neukaledonien' },
          { value: 'NZ', text: 'Neuseeland' },
          { value: 'NI', text: 'Nicaragua' },
          { value: 'NL', text: 'Niederlande' },
          { value: 'NE', text: 'Niger' },
          { value: 'NG', text: 'Nigeria' },
          { value: 'XI', text: 'Nordirland' },
          { value: 'MK', text: 'Nordmazedonien' },
          { value: 'NO', text: 'Norwegen' },
          { header: 'O' },
          { value: 'OM', text: 'Oman' },
          { value: 'AT', text: 'Österreich' },
          { header: 'P' },
          { value: 'PK', text: 'Pakistan' },
          { value: 'PS', text: 'Palästinensische Gebiete' },
          { value: 'PA', text: 'Panama' },
          { value: 'PG', text: 'Papua-Neuguinea' },
          { value: 'PY', text: 'Paraguay' },
          { value: 'PE', text: 'Peru' },
          { value: 'PH', text: 'Philippinen' },
          { value: 'PL', text: 'Polen' },
          { value: 'PT', text: 'Portugal' },
          { header: 'R' },
          { value: 'RW', text: 'Ruanda' },
          { value: 'RO', text: 'Rumänien' },
          { value: 'RU', text: 'Russische Föderation' },
          { header: 'S' },
          { value: 'SB', text: 'Salomonen' },
          { value: 'ZM', text: 'Sambia' },
          { value: 'WS', text: 'Samoa' },
          { value: 'SM', text: 'San Marino' },
          { value: 'ST', text: 'Sâo Tomé und Príncipe' },
          { value: 'SA', text: 'Saudi-Arabien' },
          { value: 'SE', text: 'Schweden' },
          { value: 'CH', text: 'Schweiz' },
          { value: 'SN', text: 'Senegal' },
          { value: 'XS', text: 'Serbien' },
          { value: 'SC', text: 'Seychellen' },
          { value: 'SL', text: 'Sierra Leone' },
          { value: 'ZW', text: 'Simbabwe' },
          { value: 'SG', text: 'Singapur' },
          { value: 'SK', text: 'Slowakei' },
          { value: 'SI', text: 'Slowenien' },
          { value: 'SO', text: 'Somalia' },
          { value: 'ES', text: 'Spanien' },
          { value: 'LK', text: 'Sri Lanka' },
          { value: 'ZA', text: 'Südafrika' },
          { value: 'SD', text: 'Sudan' },
          { value: 'SS', text: 'Südsudan' },
          { value: 'SR', text: 'Suriname' },
          { value: 'SY', text: 'Syrien' },
          { header: 'T' },
          { value: 'TJ', text: 'Tadschikistan' },
          { value: 'TW', text: 'Taiwan' },
          { value: 'TZ', text: 'Tansania' },
          { value: 'TH', text: 'Thailand' },
          { value: 'TG', text: 'Togo' },
          { value: 'TO', text: 'Tonga' },
          { value: 'TT', text: 'Trinidad und Tobago' },
          { value: 'TD', text: 'Tschad' },
          { value: 'CZ', text: 'Tschechien' },
          { value: 'TN', text: 'Tunesien' },
          { value: 'TR', text: 'Türkei' },
          { value: 'TM', text: 'Turkmenistan' },
          { value: 'TV', text: 'Tuvalu' },
          { header: 'U' },
          { value: 'UG', text: 'Uganda' },
          { value: 'UA', text: 'Ukraine' },
          { value: 'HU', text: 'Ungarn' },
          { value: 'UY', text: 'Uruguay' },
          { value: 'UZ', text: 'Usbekistan' },
          { header: 'V' },
          { value: 'VU', text: 'Vanuatu' },
          { value: 'VE', text: 'Venezuela' },
          { value: 'US', text: 'Vereinigte Staaten' },
          { value: 'VN', text: 'Vietnam' },
          { header: 'W' },
          { value: 'EH', text: 'Westsahara' },
          { header: 'Z' },
          { value: 'CF', text: 'Zentralafrikanische Republik' },
          { value: 'CY', text: 'Zypern' }
        ],
        ICD10_Version: '10 2026 GM',
        ICDO_Version: '33',
        OPS_Version: '2026',
        TNM_Version: '9',
        genderValues: [
          { value: 'W', text: this.$t('COMPONENT_PATIENT.GENDER_VALUES.FEMALE') },
          { value: 'M', text: this.$t('COMPONENT_PATIENT.GENDER_VALUES.MALE') },
          { value: 'D', text: this.$t('COMPONENT_PATIENT.GENDER_VALUES.DIVERS') },
          { value: 'X', text: this.$t('COMPONENT_PATIENT.GENDER_VALUES.INDEFINITE') },
          { value: 'U', text: this.$t('COMPONENT_PATIENT.GENDER_VALUES.UNKNOWN') }
        ],
        titleValues: ['Dipl. Ing.', 'Dipl. Kaufm.', 'Dipl. med.', 'Dr.', 'Dr. Dr.', 'Prof.', 'Prof. Dr.'],
        nameSuffixValues: ['Baron', 'Baroness', 'Freifrau', 'Freiherr', 'Fürst', 'Fürstin', 'Graf', 'Gräfin', 'Landgraf', 'Landgräfin'],
        namePrefixValues: ['de', 'de la', 'van', 'von', 'von der'],
        reportTypes: [
          { text: 'Diagnose', value: 'diagnosis' },
          { text: 'Erstmalige Vollremission', value: 'vollremission_new' },
          { text: 'Statusänderung', value: 'statusaenderung' },
          { text: 'Statusänderung Metastase', value: 'statusaenderung_metastase' },
          { text: 'Beginn Syst. Therapie', value: 'behandlungsbeginn' },
          { text: 'Ende Syst. Therapie', value: 'behandlungsendeSyst' },
          { text: 'Operation', value: 'behandlungsendeOP' },
          { text: 'Beginn Strahlentherapie', value: 'behandlungsbeginnRT' },
          { text: 'Ende Strahlentherapie', value: 'behandlungsendeRT' },
          { text: 'Tumorkonferenz', value: 'tumorConference' },
          { text: 'Tod', value: 'tod' }
        ],
        reportTypesImportedForms: {
          diagnosis: [{ text: 'Diagnose', value: 'diagnosis' }],
          systemicTherapy: [
            { text: 'Beginn Syst. Therapie', value: 'behandlungsbeginn' },
            { text: 'Ende Syst. Therapie', value: 'behandlungsendeSyst' }
          ],
          progress: [
            { text: 'Statusänderung Metastase', value: 'statusaenderung_metastase' }
          ],
          death: [{ text: 'Tod', value: 'tod' }]
        },
        reportTypeAfterCare: [
          { text: 'Weiterhin bestehende Vollremission', value: 'vollremission_cont' },
          { text: 'Keine Änderung - stable disease', value: 'statusmeldungUN' }
        ],
        mappingReportTypes: {
          diagnosis: { report: 'diagnose', form: 'diagnosis' },
          statusmeldungUN: { report: 'statusmeldung', form: 'progress' },
          statusaenderung: { report: 'statusaenderung', form: 'progress' },
          statusaenderung_metastase: { report: 'statusaenderung', form: 'progress' },
          vollremission_new: { report: 'statusaenderung', form: 'progress' },
          vollremission_cont: { report: 'statusmeldung', form: 'progress' },
          behandlungsbeginn: { report: 'behandlungsbeginn', form: 'systemicTherapy' },
          behandlungsendeSyst: { report: 'behandlungsende', form: 'systemicTherapy' },
          behandlungsendeOP: { report: 'behandlungsende', form: 'operation' },
          behandlungsbeginnRT: { report: 'behandlungsbeginn', form: 'radiationTherapy' },
          behandlungsendeRT: { report: 'behandlungsende', form: 'radiationTherapy' },
          tumorConference: { report: 'behandlungsende', form: 'tumorConference' },
          tod: { report: 'tod', form: 'death' }
        },
        registerWithAfterCare: ['Baden-Württemberg', 'Berlin-Brandenburg', 'Hessen', 'Mecklenburg-Vorpommern', 'Niedersachsen', 'Nordrhein-Westfalen', 'Rheinland-Pfalz', 'Sachsen-Anhalt', 'Thüringen'],
        moduleDependenciesToTumor: {
          prostata: new RegExp('^(C61|D07.5)'),
          mamma: new RegExp('^(C50|D05)'),
          kolo: new RegExp('^(C18|C19|C20|D01.0|D01.1|D01.2)'),
          malignes: new RegExp('^C43')
        },
        modulesAreEmpty: {
          register: {
            defaultPanel: [0, 1, 2, 3, 4, 5, 6, 8],
            modules: {
              // allgemeiner_leistungszustand: { value: true, index: 6 },
              histologie: { value: true, index: 7 },
              ptnm: { value: true, index: 9 },
              weitere_klassifikation: { value: true, index: 10 },
              fruehere_tumorerkrankung: { value: true, index: 11 },
              fernmetastase: { value: true, index: 12 },
              genetische_varianten: { value: true, index: 13 },
              modul_allgemein: { value: true, index: 14 },
              anmerkung: { value: true, index: 15 }
            }
          },
          progress: {
            defaultPanel: [0, 1, 2, 3, 4, 5, 6, 8],
            modules: {
              histologie: { value: true, index: 7 },
              weitere_klassifikation: { value: true, index: 9 },
              fernmetastase: { value: true, index: 10 },
              genetische_varianten: { value: true, index: 11 },
              modul_allgemein: { value: true, index: 12 },
              anmerkung: { value: true, index: 13 }
            }
          },
          operation: {
            defaultPanel: [0, 1, 2, 3, 4, 5, 9, 12],
            modules: {
              histologie: { value: true, index: 6 },
              tnm: { value: true, index: 7 },
              weitere_klassifikation: { value: true, index: 8 },
              op_komplikation: { value: true, index: 10 },
              genetische_varianten: { value: true, index: 11 },
              modul_allgemein: { value: true, index: 12 },
              operateure: { value: true, index: 13 },
              anmerkung: { value: true, index: 14 }
            }
          },
          radiationTherapy: {
            defaultPanel: [0, 1, 2],
            modules: {
              modul_allgemein: { value: true, index: 3 },
              anmerkung: { value: true, index: 4 }
            }
          },
          systemicTherapy: {
            defaultPanel: [0, 1, 2],
            modules: {
              // syst_nebenwirkung: { value: true, index: 2 },
              modul_allgemein: { value: true, index: 3 },
              anmerkung: { value: true, index: 4 }
            }
          },
          tumorConference: {
            defaultPanel: [0, 1, 2],
            modules: {}
          }
        },
        CertificationTypes: [
          { value: '1', text: this.$t('FORMS_DIVERSE.CERTIFICATION.TYPES.PRIMARY_CASE') },
          { value: '2', text: this.$t('FORMS_DIVERSE.CERTIFICATION.TYPES.NO_PRIMARY_CASE') },
          { value: '3', text: this.$t('FORMS_DIVERSE.CERTIFICATION.TYPES.NOT_CASE') }
        ],
        blackListDurationList: [
          { key: 'M', text: this.$t('BLACKLIST.DIALOG_DURATION.LIST_ELEMENTS.END_OF_MONTH') },
          { key: 'V', text: this.$t('BLACKLIST.DIALOG_DURATION.LIST_ELEMENTS.QUARTER_YEAR') },
          { key: 'H', text: this.$t('BLACKLIST.DIALOG_DURATION.LIST_ELEMENTS.HALF_YEAR') },
          { key: 'E', text: this.$t('BLACKLIST.DIALOG_DURATION.LIST_ELEMENTS.END_OF_YEAR') },
          { key: 'J', text: this.$t('BLACKLIST.DIALOG_DURATION.LIST_ELEMENTS.FOR_A_YEAR') },
          { key: 'P', text: this.$t('BLACKLIST.DIALOG_DURATION.LIST_ELEMENTS.PERMANENT') }
        ]
      }
    }
  }
}
